export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BaseScalar: { input: any; output: any; }
  Date: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AccessibilityCategory = {
  __typename?: 'AccessibilityCategory';
  icon?: Maybe<Image>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type AccessibilityCategoryInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessibilityCategoryUpdateInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminBackofficeSharryContentItemCreateInput = {
  backgroundColor: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  sharryContentId: Scalars['ID']['input'];
};

export type AdminBackofficeSharryContentItemUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCollaborationCreateInput = {
  collaborationKindId: Scalars['ID']['input'];
  collaboratorName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPaladin?: InputMaybe<Scalars['Boolean']['input']>;
  landId?: InputMaybe<Scalars['ID']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCollaborationUpdateInput = {
  collaborationKindId?: InputMaybe<Scalars['ID']['input']>;
  collaboratorName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPaladin?: InputMaybe<Scalars['Boolean']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminLanguageInput = {
  sort?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type AdminLikeCollectionUpdateInput = {
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coverContentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  privacySetting?: InputMaybe<PrivacySetting>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminPaymentUpdateInput = {
  id: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoicedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type AdminPostToRecommendationInput = {
  id: Scalars['ID']['input'];
};

export type AdminQualificationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCertification?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  usersCount?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminQualificationUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  requiresCertification?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  usersCount?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminRecommendationUpdateInput = {
  id: Scalars['ID']['input'];
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminSharryContentValidatorNotesInput = {
  id: Scalars['ID']['input'];
  validatorNotes: Scalars['String']['input'];
};

export type AdminSharryContentVisibleUpdateInput = {
  id: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
};

export type AdminSharryKindInput = {
  contentType?: InputMaybe<SharryContentType>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  sharrySelection?: InputMaybe<SharrySelection>;
};

export type AdminSharryKindUpdateInput = {
  contentType?: InputMaybe<SharryContentType>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
};

export type AdminSharrylandConfigUpdateInput = {
  geographicSearchRange?: InputMaybe<Scalars['Int']['input']>;
  geographicallyRelatedContentsRange?: InputMaybe<Scalars['Int']['input']>;
  maximumSharryParticipants?: InputMaybe<Array<Scalars['Int']['input']>>;
  minimumSharryParticipants?: InputMaybe<Array<Scalars['Int']['input']>>;
  privacyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recommendationAwardedCherries?: InputMaybe<Scalars['Int']['input']>;
  sharryAwardedCherries?: InputMaybe<Scalars['Int']['input']>;
  sharrylanderRelatedCount?: InputMaybe<Scalars['Int']['input']>;
  sharrylanderSearchCount?: InputMaybe<Scalars['Int']['input']>;
  staffEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  supportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminUserCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  adminProfileNotes?: InputMaybe<Scalars['String']['input']>;
  ambassador?: InputMaybe<Scalars['Boolean']['input']>;
  availableCherries?: InputMaybe<Scalars['Int']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactWhatsapp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  favouriteCategoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  freeProGold?: InputMaybe<Scalars['Boolean']['input']>;
  friendlyMunicipality?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  isShadowBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isSmallOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxBebs?: InputMaybe<Scalars['Int']['input']>;
  maxExperiences?: InputMaybe<Scalars['Int']['input']>;
  maxTours?: InputMaybe<Scalars['Int']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  plusAttributes?: InputMaybe<Scalars['JSON']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  qualificationId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  selfSignedQualification?: InputMaybe<Scalars['Boolean']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  totalCherries?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatICanDo?: InputMaybe<Scalars['String']['input']>;
  whoIAm?: InputMaybe<Scalars['String']['input']>;
  workAddress?: InputMaybe<Scalars['String']['input']>;
  workingRange?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminUserUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  adminLandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  adminProfileNotes?: InputMaybe<Scalars['String']['input']>;
  ambassador?: InputMaybe<Scalars['Boolean']['input']>;
  applicationFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  availableCherries?: InputMaybe<Scalars['Int']['input']>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  canReportEvents?: InputMaybe<Scalars['Boolean']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactWhatsapp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  favouriteCategoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  freeProGold?: InputMaybe<Scalars['Boolean']['input']>;
  friendlyMunicipality?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  isShadowBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isSmallOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxBebs?: InputMaybe<Scalars['Int']['input']>;
  maxExperiences?: InputMaybe<Scalars['Int']['input']>;
  maxTours?: InputMaybe<Scalars['Int']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  networkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  plusAttributes?: InputMaybe<Scalars['JSON']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  qualificationId?: InputMaybe<Scalars['ID']['input']>;
  refusedGeolocation?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  selfSignedQualification?: InputMaybe<Scalars['Boolean']['input']>;
  sharrylandPartner?: InputMaybe<Scalars['Boolean']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionEndsAt?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  totalCherries?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatICanDo?: InputMaybe<Scalars['String']['input']>;
  whoIAm?: InputMaybe<Scalars['String']['input']>;
  workAddress?: InputMaybe<Scalars['String']['input']>;
  workingRange?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminWrongdoingReportUpdateInput = {
  id: Scalars['ID']['input'];
  status: WrongdoingStatus;
};

export type Advertisement = {
  __typename?: 'Advertisement';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonColor?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  layoutType?: Maybe<AdvertisementLayout>;
  logo?: Maybe<Image>;
  owner?: Maybe<User>;
  sharryContents?: Maybe<Array<SharryContent>>;
  sort?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<AdvertisementStatus>;
  textColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdvertisementCreateInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  layoutType?: InputMaybe<AdvertisementLayout>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AdvertisementStatus>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum AdvertisementLayout {
  HomepageFeaturedContent = 'homepage_featured_content',
  SharryContent = 'sharry_content'
}

export enum AdvertisementStatus {
  Hidden = 'hidden',
  Visible = 'visible'
}

export type AdvertisementUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  layoutType?: InputMaybe<AdvertisementLayout>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AdvertisementStatus>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Analytic = {
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interactionType?: Maybe<AnalyticInteractionType>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<AnalyticPlatform>;
};

export type AnalyticGoogleMap = Analytic & {
  __typename?: 'AnalyticGoogleMap';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interactionType?: Maybe<AnalyticInteractionType>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<AnalyticPlatform>;
};

export type AnalyticGoogleMapCreateInput = {
  interactedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionType?: InputMaybe<AnalyticInteractionType>;
  placeId: Scalars['String']['input'];
};

export enum AnalyticInteractionType {
  Clicked = 'clicked',
  Session = 'session',
  Viewed = 'viewed'
}

export enum AnalyticPlatform {
  App = 'app',
  Web = 'web'
}

export type AnalyticSession = Analytic & {
  __typename?: 'AnalyticSession';
  analyticSessionPages?: Maybe<Array<AnalyticSessionPage>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interactionType?: Maybe<AnalyticInteractionType>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  logged?: Maybe<Scalars['Boolean']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  noIp?: Maybe<Scalars['Boolean']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<AnalyticPlatform>;
};

export type AnalyticSessionCreateInput = {
  interactedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionType?: InputMaybe<AnalyticInteractionType>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logged?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  noIp?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<AnalyticPlatform>;
};

export type AnalyticSessionPage = {
  __typename?: 'AnalyticSessionPage';
  analyticSession?: Maybe<AnalyticSession>;
  id: Scalars['ID']['output'];
  normalizedPath?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
};

export type AnalyticSessionPageCreateInput = {
  analyticSessionId: Scalars['ID']['input'];
  normalizedPath?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticSessionUpdateInput = {
  id: Scalars['ID']['input'];
  interactedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionType?: InputMaybe<AnalyticInteractionType>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logged?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  noIp?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<AnalyticPlatform>;
};

export type AnalyticStats = {
  __typename?: 'AnalyticStats';
  averagePageVisit?: Maybe<AveragePageVisit>;
  averagePageVisitTime?: Maybe<AveragePageVisitTime>;
  bounceRate?: Maybe<BounceRate>;
  top10Urls?: Maybe<Scalars['JSON']['output']>;
  visitorsCount?: Maybe<Visitor>;
};

export type AnalyticWidget = Analytic & {
  __typename?: 'AnalyticWidget';
  content?: Maybe<AnalyticWidgetUnion>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interactionType?: Maybe<AnalyticInteractionType>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<AnalyticWidgetLayout>;
  origin?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<AnalyticPlatform>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticWidgetContent {
  SellingItem = 'selling_item',
  SharryContent = 'sharry_content',
  User = 'user'
}

export type AnalyticWidgetCreateInput = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<AnalyticWidgetContent>;
  interactedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  interactionType?: InputMaybe<AnalyticInteractionType>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<AnalyticWidgetLayout>;
  origin?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticWidgetLayout {
  Carousel = 'carousel',
  Event = 'event',
  Grid = 'grid',
  List = 'list',
  Post = 'post',
  SellingItem = 'selling_item',
  Sharry = 'sharry',
  User = 'user',
  Wonder = 'wonder'
}

/** Generic content type, used for analytic_widgets */
export type AnalyticWidgetUnion = Event | Post | Sharry | User | Wonder;

export type AttachedDocument = {
  __typename?: 'AttachedDocument';
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<AttachedDocumentAttachmentEnum>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AttachedDocumentAttachmentEnum {
  CustomRequestAttachment = 'custom_request_attachment',
  SharryContentAttachment = 'sharry_content_attachment',
  SharryWhatWeWillDoAttachment = 'sharry_what_we_will_do_attachment',
  TermsAndConditionsAttachment = 'terms_and_conditions_attachment',
  UserAttachment = 'user_attachment'
}

export type AttachedDocumentCreateInput = {
  file: Scalars['Upload']['input'];
  kind?: InputMaybe<AttachedDocumentAttachmentEnum>;
  name: Scalars['String']['input'];
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AttachedDocumentUpdateInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthHeaderData = {
  __typename?: 'AuthHeaderData';
  accessToken?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type AuthProviderAppleSignInInput = {
  /** Token returned by the Apple SDK upon login. */
  accessToken: Scalars['String']['input'];
  fromWeb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthProviderAppleSignUpInput = {
  /** Token returned by the Apple SDK upon login. */
  accessToken: Scalars['String']['input'];
  /** Example format: YYYY-MM-DD */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  fromWeb?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type AuthProviderEmailSignInInput = {
  /** Email */
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthProviderEmailSignUpInput = {
  /** Example format: YYYY-MM-DD */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
};

export type AuthProviderFacebookSignInInput = {
  /** Token returned by the Facebook SDK upon login. */
  accessToken: Scalars['String']['input'];
};

export type AuthProviderFacebookSignUpInput = {
  /** Token returned by the Facebook SDK upon login. */
  accessToken: Scalars['String']['input'];
  /** Example format: YYYY-MM-DD */
  birthday?: InputMaybe<Scalars['Date']['input']>;
};

export type AuthProviderGoogleSignInInput = {
  /** Token returned by the Google SDK upon login. */
  accessToken: Scalars['String']['input'];
  /** Given name from Google */
  name?: InputMaybe<Scalars['String']['input']>;
  /** family name from Google */
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type AuthProviderGoogleSignUpInput = {
  /** Token returned by the Google SDK upon login. */
  accessToken: Scalars['String']['input'];
  /** Example format: YYYY-MM-DD */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** Given name from Google */
  name?: InputMaybe<Scalars['String']['input']>;
  /** family name from Google */
  surname?: InputMaybe<Scalars['String']['input']>;
};

/** Objects which may be returned from the autocompleting search bar no places */
export type AutocompleteNoPlaces = Event | Hashtag | Sharry | User | Wonder;

/** Objects which may be returned from the autocompleting search bar */
export type AutocompleteSearchResult = Event | Hashtag | Place | Sharry | User | Wonder;

export type AveragePageVisit = {
  __typename?: 'AveragePageVisit';
  average?: Maybe<Scalars['Float']['output']>;
  pageCount?: Maybe<Array<PageCount>>;
};

export type AveragePageVisitTime = {
  __typename?: 'AveragePageVisitTime';
  average?: Maybe<Scalars['Float']['output']>;
  pageTime?: Maybe<Array<PageTime>>;
};

export type BackofficeSharryContentItem = {
  __typename?: 'BackofficeSharryContentItem';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  sharryContent: SharryContent;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BecomePro = {
  __typename?: 'BecomePro';
  dummy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BehalfOfUserCart = {
  __typename?: 'BehalfOfUserCart';
  cart?: Maybe<Cart>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  status?: Maybe<BehalfOfUserStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BehalfOfUserCartCreateInput = {
  title: Scalars['String']['input'];
};

export type BehalfOfUserCartUpdateInput = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export enum BehalfOfUserStatus {
  Completed = 'completed',
  Created = 'created'
}

export type BillingInfo = {
  __typename?: 'BillingInfo';
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fiscalCode?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pec?: Maybe<Scalars['String']['output']>;
  personKind?: Maybe<PersonKind>;
  province?: Maybe<Scalars['String']['output']>;
  sdiCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BillingInfoInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pec?: InputMaybe<Scalars['String']['input']>;
  personKind?: InputMaybe<PersonKind>;
  province?: InputMaybe<Scalars['String']['input']>;
  sdiCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type BlockContentInput = {
  contentId: Scalars['ID']['input'];
  contentType: ReportableEntityEnum;
};

export type BounceRate = {
  __typename?: 'BounceRate';
  bounced?: Maybe<Scalars['Int']['output']>;
  notBounced?: Maybe<Scalars['Int']['output']>;
};

export enum CarouselableEntityEnum {
  Land = 'land',
  LikeCollection = 'like_collection',
  SharryContent = 'sharry_content',
  User = 'user'
}

export type Cart = {
  __typename?: 'Cart';
  cartItems?: Maybe<Array<CartItem>>;
  cartItemsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type CartCartItemsArgs = {
  statuses?: InputMaybe<Array<CartItemStatusEnum>>;
};


export type CartCartItemsCountArgs = {
  statuses?: InputMaybe<Array<CartItemStatusEnum>>;
};

export type CartCreateInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  available: Scalars['Boolean']['output'];
  cart?: Maybe<Cart>;
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  custom?: Maybe<Scalars['Boolean']['output']>;
  fullPrice?: Maybe<Scalars['Float']['output']>;
  giftCard?: Maybe<GiftCard>;
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentGiftCardPrice?: Maybe<Scalars['Float']['output']>;
  paymentPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceChanged?: Maybe<Scalars['Boolean']['output']>;
  refund?: Maybe<Refund>;
  refundable?: Maybe<Scalars['Boolean']['output']>;
  sharryContent?: Maybe<SharryContent>;
  sharryVariants?: Maybe<Array<SharryVariant>>;
  shippable: Scalars['Boolean']['output'];
  shipping?: Maybe<CartItemShippingEnum>;
  shopOrder?: Maybe<ShopOrder>;
  split?: Maybe<Scalars['Boolean']['output']>;
  splittable: Scalars['Boolean']['output'];
  splittableVariants?: Maybe<Array<SharryVariant>>;
  status?: Maybe<CartItemStatusEnum>;
  transferDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CartItemRefundableArgs = {
  asOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartItemCreateInput = {
  cartUuid?: InputMaybe<Scalars['String']['input']>;
  onBehalfOfUser?: InputMaybe<Scalars['Boolean']['input']>;
  sharryVariantId: Scalars['ID']['input'];
};

export enum CartItemShippingEnum {
  HomeDelivery = 'home_delivery',
  NoShipping = 'no_shipping',
  Pickup = 'pickup'
}

export enum CartItemStatusEnum {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Created = 'created',
  Expired = 'expired',
  Paid = 'paid',
  PaymentIntent = 'payment_intent',
  RefundRequested = 'refund_requested',
  Refunded = 'refunded',
  Refused = 'refused',
  Requested = 'requested'
}

export type CartItemStatusUpdateInput = {
  id: Scalars['ID']['input'];
  status: CartItemStatusEnum;
};

export type CartItemUpdateInput = {
  id: Scalars['ID']['input'];
  shipping?: InputMaybe<CartItemShippingEnum>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartUpdateInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Category = {
  __typename?: 'Category';
  hasSharrySoldBySharryland: Scalars['Boolean']['output'];
  icon?: Maybe<Image>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
  param?: Maybe<Scalars['String']['output']>;
  previewImage?: Maybe<Image>;
  searchBanners?: Maybe<Array<SearchBanner>>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type CategoryInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  normalizedName?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryUpdateInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/** Returns users search and current user groups */
export type ChatUnion = Conversation | User;

export type CherryDiscount = {
  __typename?: 'CherryDiscount';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<CherryDiscountStatusEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user: User;
};

export enum CherryDiscountStatusEnum {
  Active = 'active',
  Created = 'created',
  Expired = 'expired',
  Used = 'used'
}

export type CherryGoal = {
  __typename?: 'CherryGoal';
  cherryAmount?: Maybe<Scalars['Int']['output']>;
  cherryResourceType: CherryResource;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CherryResource {
  CherryDiscount = 'cherry_discount',
  Coupon = 'coupon',
  GiftCard = 'gift_card'
}

export type CherryTransaction = {
  __typename?: 'CherryTransaction';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  land?: Maybe<Land>;
  sharryContent?: Maybe<SharryContent>;
  transactionType: TransactionType;
  user: User;
};

export type Collaboration = {
  __typename?: 'Collaboration';
  collaborationKind?: Maybe<CollaborationKind>;
  collaboratorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isPaladin?: Maybe<Scalars['Boolean']['output']>;
  land?: Maybe<Land>;
  sharryContent?: Maybe<SharryContent>;
  user?: Maybe<User>;
};

export type CollaborationCreateInput = {
  collaboratorName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  landId?: InputMaybe<Scalars['ID']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CollaborationKind = {
  __typename?: 'CollaborationKind';
  id: Scalars['ID']['output'];
  publicDefault?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CollaborationKindCreateInput = {
  publicDefault?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type CollaborationKindUpdateInput = {
  id: Scalars['ID']['input'];
  publicDefault?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationUrlUpdate = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationUrls = {
  __typename?: 'CollaborationUrls';
  imageUrl?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type CollectionClap = {
  __typename?: 'CollectionClap';
  id: Scalars['ID']['output'];
  likeCollection: LikeCollection;
  user: User;
};

export type CollectionClapCreateInput = {
  likeCollectionId: Scalars['ID']['input'];
};

/** Entities in community page */
export type CommunityPost = NotificationFeed | Post;

export type ConfirmDirectUploadInput = {
  recordId: Scalars['ID']['input'];
  recordName: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  signedBlobId: Scalars['ID']['input'];
};

export enum ContactsRequest {
  CanReportEvents = 'can_report_events',
  Collaboration = 'collaboration',
  Copyright = 'copyright',
  Customisation = 'customisation',
  Data = 'data',
  EmailChange = 'email_change',
  Information = 'information',
  Others = 'others',
  Problem = 'problem',
  Proposal = 'proposal',
  UpdateWonder = 'update_wonder'
}

export enum ContactsRole {
  Accommodation = 'accommodation',
  Artisan = 'artisan',
  Association = 'association',
  Catering = 'catering',
  Company = 'company',
  Guide = 'guide',
  Journalist = 'journalist',
  Municipality = 'municipality',
  Other = 'other',
  Photographer = 'photographer',
  Private = 'private',
  Productor = 'productor',
  ResponsibleCulturalAsset = 'responsible_cultural_asset',
  ServiceProvider = 'service_provider',
  TerritorialBody = 'territorial_body',
  TourOperator = 'tour_operator',
  Videomaker = 'videomaker'
}

export type ContentCarousel = {
  __typename?: 'ContentCarousel';
  contents?: Maybe<Array<ContentEntity>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentCarouselCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  sharryContentId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type ContentCarouselEntityCreateInput = {
  contentCarouselId: Scalars['ID']['input'];
  contentId: Scalars['ID']['input'];
  contentType: CarouselableEntityEnum;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentCarouselEntityUpdateInput = {
  contentCarouselId: Scalars['ID']['input'];
  contentId: Scalars['ID']['input'];
  contentType: CarouselableEntityEnum;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentCarouselUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  sharryContentId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type ContentCreateAccessibilityInput = {
  accessibilityCategoryId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  suitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentCreateAttachedDocumentInput = {
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
};

export type ContentCreateGalleryContentInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<GalleryContentCreateEmbedInput>;
  image?: InputMaybe<GalleryContentCreateImageInput>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/** Generic content types, used for carousels and such */
export type ContentEntity = Event | LikeCollection | Post | Sharry | User | Wonder;

export type ContentFavourite = {
  __typename?: 'ContentFavourite';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  sharryContent: SharryContent;
  user: User;
};

export type ContentFavouriteCreateInput = {
  sharryContentId: Scalars['ID']['input'];
  /** It's deprecated and ignored... it uses the current logged in user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLike = {
  __typename?: 'ContentLike';
  content: ContentEntity;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  likeCollection?: Maybe<LikeCollection>;
  likeCollections?: Maybe<Array<LikeCollection>>;
  sharryContent?: Maybe<SharryContent>;
  user: User;
};

export type ContentLikeAddCollectionInput = {
  contentLikeId: Scalars['ID']['input'];
  likeCollectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLikeCreateInput = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<CarouselableEntityEnum>;
  /** use ContentLikeAddCollection */
  likeCollectionId?: InputMaybe<Scalars['ID']['input']>;
  /** use content_id + content_type */
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentLikeRemoveCollectionInput = {
  contentLikeId: Scalars['ID']['input'];
  likeCollectionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Entities that might create or own a SharryContent */
export type ContentOwner = User;

/** Generic content object */
export type ContentUnion = Event | Land | Post | Sharry | User | Wonder;

export type Conversation = {
  __typename?: 'Conversation';
  cartItems?: Maybe<Array<CartItem>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  lastMessage?: Maybe<Message>;
  messages?: Maybe<Array<Message>>;
  owner?: Maybe<User>;
  sharryGroup?: Maybe<Scalars['Boolean']['output']>;
  totalMessages?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  users?: Maybe<Array<User>>;
};


export type ConversationMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationCreateInput = {
  receiverId: Scalars['ID']['input'];
};

export type ConversationGroupCreateInput = {
  groupName: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ConversationGroupUpdateInput = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CookiePreference = {
  __typename?: 'CookiePreference';
  advertising?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  functional?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  necessary?: Maybe<Scalars['Boolean']['output']>;
  statistic?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type CookiePreferenceCreateInput = {
  advertising?: InputMaybe<Scalars['Boolean']['input']>;
  functional?: InputMaybe<Scalars['Boolean']['input']>;
  necessary?: InputMaybe<Scalars['Boolean']['input']>;
  statistic?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type CookiePreferenceUpdateInput = {
  advertising?: InputMaybe<Scalars['Boolean']['input']>;
  functional?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  necessary?: InputMaybe<Scalars['Boolean']['input']>;
  statistic?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Coordinates = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CoordinatesFields = {
  __typename?: 'CoordinatesFields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type CoordinatesInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type CoordinatorApplicationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: CoordinatorsRole;
  surname: Scalars['String']['input'];
};

export enum CoordinatorsRole {
  AlpineGuide = 'alpine_guide',
  Companion = 'companion',
  EnvironmentalGuide = 'environmental_guide',
  Other = 'other',
  TouristGuide = 'tourist_guide'
}

/** File information required to prepare a direct upload */
export type CreateDirectUploadInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDirectUpload. */
export type CreateDirectUploadPayload = {
  __typename?: 'CreateDirectUploadPayload';
  directUpload: DirectUpload;
};

export enum CurrencyCode {
  Aud = 'AUD',
  Bgn = 'BGN',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Myr = 'MYR',
  Nok = 'NOK',
  Nzd = 'NZD',
  Php = 'PHP',
  Pln = 'PLN',
  Ron = 'RON',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type CustomCover = {
  __typename?: 'CustomCover';
  author?: Maybe<Scalars['String']['output']>;
  copyrightLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionIt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  licenseType?: Maybe<GalleryContentLicenseEnum>;
  likeCollection?: Maybe<LikeCollection>;
  sharryContent?: Maybe<SharryContent>;
};

export type CustomCoverCreateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  customCoverSharryContentId?: InputMaybe<Scalars['ID']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionIt?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  likeCollectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomCoverUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionIt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
};

export type CustomLink = {
  __typename?: 'CustomLink';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type CustomLinkCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CustomLinkUpdateInput = {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CustomNotification = {
  __typename?: 'CustomNotification';
  allRegion?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  latitude?: Maybe<Scalars['Float']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxDistance?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<CustomNotificationMode>;
  previewSentCount?: Maybe<Scalars['Int']['output']>;
  previewUsers?: Maybe<Array<User>>;
  readCount?: Maybe<Scalars['Int']['output']>;
  recipient?: Maybe<CustomNotificationRecipient>;
  region?: Maybe<Scalars['String']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  sentTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CustomNotificationCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allRegion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than 2MB! */
  image?: InputMaybe<Scalars['Upload']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<CustomNotificationMode>;
  province?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<CustomNotificationRecipient>;
  region?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export enum CustomNotificationMode {
  Email = 'email',
  Notification = 'notification',
  NotificationAndEmail = 'notification_and_email'
}

export enum CustomNotificationRecipient {
  AllUsers = 'all_users',
  GoldUsers = 'gold_users',
  Team = 'team',
  VisibleUsers = 'visible_users'
}

export type CustomNotificationUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allRegion?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** Less than 2MB! */
  image?: InputMaybe<Scalars['Upload']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<CustomNotificationMode>;
  province?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<CustomNotificationRecipient>;
  region?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DateRange = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
};

export type DefinitionInput = {
  definitionType?: InputMaybe<Scalars['String']['input']>;
  definitionValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Device = {
  __typename?: 'Device';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
};

export type DeviceInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Represents direct upload credentials */
export type DirectUpload = {
  __typename?: 'DirectUpload';
  blobId: Scalars['ID']['output'];
  headers: Scalars['String']['output'];
  signedBlobId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type DraftRecommendationUpdateInput = {
  accessibilityCategories?: InputMaybe<Array<WonderUpdateAccessibilityCategoryInput>>;
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  areYouTheOwner?: InputMaybe<Scalars['Boolean']['input']>;
  attachedDocuments?: InputMaybe<Array<ContentCreateAttachedDocumentInput>>;
  audio?: InputMaybe<Scalars['Upload']['input']>;
  audioSignature?: InputMaybe<Scalars['Upload']['input']>;
  audioText?: InputMaybe<Scalars['String']['input']>;
  beginsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  curatedRelatedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  galleryContents?: InputMaybe<Array<ContentCreateGalleryContentInput>>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  geographicallyExcludedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hasTime?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  hideCreator?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  itinerary?: InputMaybe<Scalars['JSON']['input']>;
  itineraryIndexIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  monthsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  paladinUrls?: InputMaybe<Array<CollaborationUrlUpdate>>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  pictureCollageAsCover?: InputMaybe<Scalars['Boolean']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<Scalars['JSON']['input']>;
  recommendationKind?: InputMaybe<RecommendationKind>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresBooking?: InputMaybe<Scalars['Boolean']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  resourceConditions?: InputMaybe<Scalars['String']['input']>;
  resourceProducts?: InputMaybe<Scalars['JSON']['input']>;
  resourceTextAfter?: InputMaybe<Scalars['String']['input']>;
  resourceTextBefore?: InputMaybe<Scalars['String']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  showDirections?: InputMaybe<Scalars['Boolean']['input']>;
  showMaps?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<SharryContentStatus>;
  story?: InputMaybe<Scalars['String']['input']>;
  storyPreview?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suggestedTime?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  travelSuggestions?: InputMaybe<Scalars['JSON']['input']>;
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  validatorNotes?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatItIs?: InputMaybe<Scalars['String']['input']>;
  whatNotToMiss?: InputMaybe<Scalars['String']['input']>;
  whatOther?: InputMaybe<Scalars['String']['input']>;
  whatToRemember?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecial?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecialForYou?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DraftSharryUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  animalsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  availableForBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  availableForBusinessSort?: InputMaybe<Scalars['Int']['input']>;
  badWeatherInfo?: InputMaybe<Scalars['String']['input']>;
  bebDescription?: InputMaybe<Scalars['String']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  covid19Info?: InputMaybe<Scalars['String']['input']>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  customRequestsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customRequestsWeekdays?: InputMaybe<Array<SharryWeekdays>>;
  deliveryTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  freeSharryKind?: InputMaybe<FreeSharryKind>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  invoicesRequestsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  involvedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineHelper?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoEmbedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  itinerary?: InputMaybe<Scalars['JSON']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  maxAttendants?: InputMaybe<Scalars['Int']['input']>;
  meetingLocation?: InputMaybe<Scalars['String']['input']>;
  meetingLocationLatitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLocationLongitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLocationNotes?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  minAttendants?: InputMaybe<Scalars['Int']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  pictureCollageAsCover?: InputMaybe<Scalars['Boolean']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  practicalInfo?: InputMaybe<Scalars['String']['input']>;
  pricePerChild?: InputMaybe<Scalars['Float']['input']>;
  pricePerPerson?: InputMaybe<Scalars['Float']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  reducedMobility?: InputMaybe<Scalars['Boolean']['input']>;
  reducedMobilityNotes?: InputMaybe<Scalars['String']['input']>;
  refundable?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  responseTime?: InputMaybe<Scalars['Int']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  servicesSharryContents?: InputMaybe<Array<ServicesSharryContentsInput>>;
  sharryDiscounts?: InputMaybe<Array<SharryDiscountInput>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  sharryVariants?: InputMaybe<Array<SharryVariantInput>>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  showDirections?: InputMaybe<Scalars['Boolean']['input']>;
  showMaps?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  soldBySharryland?: InputMaybe<Scalars['Boolean']['input']>;
  splitAgeVariant?: InputMaybe<Scalars['Boolean']['input']>;
  startingPrice?: InputMaybe<Scalars['Float']['input']>;
  startingPriceKind?: InputMaybe<StartingPriceKind>;
  startingPriceNotes?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unlimitedAttendants?: InputMaybe<Scalars['Boolean']['input']>;
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  validatorNotes?: InputMaybe<Scalars['String']['input']>;
  variantDuration?: InputMaybe<VariantDurationInput>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatToBring?: InputMaybe<Scalars['String']['input']>;
  whatWeWillDo?: InputMaybe<Scalars['String']['input']>;
  whatWeWillDoAttachment?: InputMaybe<ContentCreateAttachedDocumentInput>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Event = SharryContent & {
  __typename?: 'Event';
  accessibility?: Maybe<Scalars['Boolean']['output']>;
  accessibilityCategories?: Maybe<Array<SharryContentAccessibilityCategory>>;
  accessibilityNotes?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  advertisements?: Maybe<Array<Advertisement>>;
  attachedDocuments?: Maybe<Array<AttachedDocument>>;
  audio?: Maybe<Scalars['String']['output']>;
  audioDuration?: Maybe<Scalars['Float']['output']>;
  audioSignature?: Maybe<Scalars['String']['output']>;
  audioSignatureDuration?: Maybe<Scalars['Float']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  beginsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Category>>;
  clappers?: Maybe<Array<User>>;
  clappingReviewCount?: Maybe<Scalars['Int']['output']>;
  collaborations?: Maybe<Array<Collaboration>>;
  contentCarousels?: Maybe<Array<ContentCarousel>>;
  contentFavourites?: Maybe<Array<ContentFavourite>>;
  contentLikes?: Maybe<Array<ContentLike>>;
  contentType?: Maybe<Scalars['String']['output']>;
  coverPicture?: Maybe<GalleryImage>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<ContentOwner>;
  curatedRelatedSharryContents?: Maybe<Array<SharryContent>>;
  customCover?: Maybe<CustomCover>;
  customLink?: Maybe<Scalars['String']['output']>;
  customLinkLabel?: Maybe<Scalars['String']['output']>;
  customProvince?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  eventInstances?: Maybe<Array<EventInstance>>;
  eventRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  followers?: Maybe<Array<User>>;
  freeSharryKind?: Maybe<FreeSharryKind>;
  galleryContents?: Maybe<Array<GalleryContent>>;
  /** @deprecated Use gallery contents PLS */
  galleryImages?: Maybe<Array<GalleryImage>>;
  genericContact?: Maybe<Scalars['String']['output']>;
  geographicallyRelatedContents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedEvents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharries?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharrylanders?: Maybe<Array<UserSearchResult>>;
  geographicallyRelatedWonders?: Maybe<Array<SharryContent>>;
  hasCustomCover?: Maybe<Scalars['Boolean']['output']>;
  hasTime?: Maybe<Scalars['Boolean']['output']>;
  hashtags?: Maybe<Array<Hashtag>>;
  id: Scalars['ID']['output'];
  imTheOwner?: Maybe<Scalars['Boolean']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  involvedEntities?: Maybe<Array<ContentEntity>>;
  involvedSharryContents?: Maybe<Array<SharryContent>>;
  isRecommendation?: Maybe<Scalars['Boolean']['output']>;
  isShadowBanned?: Maybe<Scalars['Boolean']['output']>;
  itineraryNew?: Maybe<Itinerary>;
  keywords?: Maybe<Array<Keyword>>;
  landIds?: Maybe<Array<Scalars['ID']['output']>>;
  lastCommentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastEventInstance?: Maybe<EventInstance>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mapPicture?: Maybe<Image>;
  mayChangeDatetime?: Maybe<Scalars['Boolean']['output']>;
  meetingLocation?: Maybe<Scalars['String']['output']>;
  metaTag?: Maybe<MetaTag>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  nextEventInstance?: Maybe<EventInstance>;
  nextUpcomingInstanceDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<ContentOwner>;
  ownerContentClaps?: Maybe<Array<OwnerContentClap>>;
  ownerContentClapsCount?: Maybe<Scalars['Int']['output']>;
  ownerLabel?: Maybe<EventOwnerLabel>;
  paladinUrls?: Maybe<Array<CollaborationUrls>>;
  param?: Maybe<Scalars['String']['output']>;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom cover. */
  pictureCollageAsCover?: Maybe<Scalars['Boolean']['output']>;
  pnrr?: Maybe<Scalars['Boolean']['output']>;
  pnrrContent?: Maybe<Pnrr>;
  posterImage?: Maybe<Scalars['JSON']['output']>;
  postsRelated?: Maybe<Array<SharryContent>>;
  postsRelatedCount?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publisher?: Maybe<User>;
  recipeNew?: Maybe<Array<Recipe>>;
  region?: Maybe<Scalars['String']['output']>;
  requiresBooking?: Maybe<Scalars['Boolean']['output']>;
  requiresPayment?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<Array<SharryReview>>;
  searchableAddress?: Maybe<Scalars['String']['output']>;
  seasons?: Maybe<Array<SeasonEnum>>;
  sharryDiscounts?: Maybe<Array<SharryDiscount>>;
  sharryIndex?: Maybe<Array<SharryContentIndices>>;
  sharryKind?: Maybe<SharryKind>;
  sharryRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  sharrySelection?: Maybe<SharrySelection>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCustomCarousels?: Maybe<Scalars['Boolean']['output']>;
  showDirections?: Maybe<Scalars['Boolean']['output']>;
  showMaps?: Maybe<Scalars['Boolean']['output']>;
  showRelatedCarousels?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  staticMap?: Maybe<Image>;
  status: SharryContentStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedTime?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  totalReviewCount?: Maybe<Scalars['Int']['output']>;
  unpublishedReviews?: Maybe<Array<SharryReview>>;
  /** Event instances that will begin in the future */
  upcomingEventInstances?: Maybe<Array<EventInstance>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  validatorNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated visibility is deprecated. Use suspended/adminHidden status instead. */
  visible?: Maybe<Scalars['Boolean']['output']>;
  visibleAdvertisements?: Maybe<Array<Advertisement>>;
  visitDuration?: Maybe<VisitDuration>;
  website?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  whyItsSpecialForYou?: Maybe<Scalars['String']['output']>;
  wizardSeenSteps?: Maybe<Array<Scalars['String']['output']>>;
  wonderRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
};


export type EventLandIdsArgs = {
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventPostsRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCreateInput = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  accessibilityCategories?: InputMaybe<Array<ContentCreateAccessibilityInput>>;
  accessibilityNotes?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachedDocuments?: InputMaybe<Array<ContentCreateAttachedDocumentInput>>;
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customLink?: InputMaybe<Scalars['String']['input']>;
  customLinkLabel?: InputMaybe<Scalars['String']['input']>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  /** While i can't really deprecate this, don't use it. Use attached documents */
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  freeSharryKind?: InputMaybe<FreeSharryKind>;
  galleryContents?: InputMaybe<Array<ContentCreateGalleryContentInput>>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  involvedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  mayChangeDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  meetingLocation?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerLabel?: InputMaybe<EventOwnerLabel>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresBooking?: InputMaybe<Scalars['Boolean']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  suggestedTime?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecialForYou?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventInstance = {
  __typename?: 'EventInstance';
  beginsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dateMap?: Maybe<Scalars['JSON']['output']>;
  datesExcluded?: Maybe<Array<Scalars['ISO8601Date']['output']>>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventStatus?: Maybe<EventStatus>;
  externalLink?: Maybe<Scalars['String']['output']>;
  hasDates?: Maybe<Scalars['Boolean']['output']>;
  hasTime?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalLink?: Maybe<Scalars['String']['output']>;
  isRecurrent?: Maybe<Scalars['Boolean']['output']>;
  labelLink?: Maybe<Scalars['String']['output']>;
  sharryContent: Event;
};

export type EventInstanceCreateInput = {
  beginsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dateMap?: InputMaybe<Scalars['JSON']['input']>;
  datesExcluded?: InputMaybe<Array<Scalars['ISO8601Date']['input']>>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventStatus?: InputMaybe<EventStatus>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  hasDates?: InputMaybe<Scalars['Boolean']['input']>;
  hasTime?: InputMaybe<Scalars['Boolean']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  isRecurrent?: InputMaybe<Scalars['Boolean']['input']>;
  labelLink?: InputMaybe<Scalars['String']['input']>;
  sharryContentId: Scalars['ID']['input'];
};

export type EventInstanceUpdateInput = {
  beginsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dateMap?: InputMaybe<Scalars['JSON']['input']>;
  datesExcluded?: InputMaybe<Array<Scalars['ISO8601Date']['input']>>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventStatus?: InputMaybe<EventStatus>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  hasDates?: InputMaybe<Scalars['Boolean']['input']>;
  hasTime?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  internalLink?: InputMaybe<Scalars['String']['input']>;
  isRecurrent?: InputMaybe<Scalars['Boolean']['input']>;
  labelLink?: InputMaybe<Scalars['String']['input']>;
};

/** event owner label */
export enum EventOwnerLabel {
  Organized = 'organized',
  Reported = 'reported'
}

/** event status */
export enum EventStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  SoldOut = 'sold_out'
}

export type EventUpdateAccessibilityCategoryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  accessibilityCategoryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  suitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventUpdateInput = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  accessibilityCategories?: InputMaybe<Array<EventUpdateAccessibilityCategoryInput>>;
  accessibilityNotes?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audio?: InputMaybe<Scalars['Upload']['input']>;
  audioSignature?: InputMaybe<Scalars['Upload']['input']>;
  audioText?: InputMaybe<Scalars['String']['input']>;
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  curatedRelatedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customLink?: InputMaybe<Scalars['String']['input']>;
  customLinkLabel?: InputMaybe<Scalars['String']['input']>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  freeSharryKind?: InputMaybe<FreeSharryKind>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  geographicallyExcludedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  involvedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  mayChangeDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  meetingLocation?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerLabel?: InputMaybe<EventOwnerLabel>;
  ownerType?: InputMaybe<SharryContentOwnerType>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  pictureCollageAsCover?: InputMaybe<Scalars['Boolean']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresBooking?: InputMaybe<Scalars['Boolean']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  showDirections?: InputMaybe<Scalars['Boolean']['input']>;
  showMaps?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suggestedTime?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  validatorNotes?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecialForYou?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExchangeCurrency = {
  __typename?: 'ExchangeCurrency';
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: CurrencyCode;
  id: Scalars['ID']['output'];
  rate: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Exif = {
  __typename?: 'Exif';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  searchableAddress?: Maybe<Scalars['String']['output']>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
};

export type Faq = {
  __typename?: 'Faq';
  faqSections?: Maybe<Array<FaqSection>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  slug: Scalars['String']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleEn?: Maybe<Scalars['String']['output']>;
  subtitleIt?: Maybe<Scalars['String']['output']>;
  target?: Maybe<FaqTargetEnum>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqBody = {
  __typename?: 'FaqBody';
  body?: Maybe<Scalars['String']['output']>;
  bodyEn?: Maybe<Scalars['String']['output']>;
  bodyIt?: Maybe<Scalars['String']['output']>;
  expanded?: Maybe<Scalars['Boolean']['output']>;
  faqSection: FaqSection;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqBodyCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  expanded?: InputMaybe<Scalars['Boolean']['input']>;
  faqSectionId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqBodyUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  expanded?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqCreateInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<FaqTargetEnum>;
  title: Scalars['String']['input'];
};

export type FaqSection = {
  __typename?: 'FaqSection';
  faq: Faq;
  faqBodies?: Maybe<Array<FaqBody>>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleEn?: Maybe<Scalars['String']['output']>;
  subtitleIt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqSectionCreateInput = {
  faqId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSectionUpdateInput = {
  id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FaqTargetEnum {
  Business = 'business',
  Corporate = 'corporate',
  ForAll = 'for_all'
}

export type FaqUpdateInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<FaqTargetEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FavouriteLanguage {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

export type FeaturedCard = {
  __typename?: 'FeaturedCard';
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiringAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  freeFeaturedCard?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  latitude?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Image>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  price?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sharryKind?: Maybe<SharryKind>;
  sharrySelection?: Maybe<SharrySelection>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FeaturedCardStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type FeaturedCardCreateInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  expiringAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FeaturedCardStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export enum FeaturedCardStatus {
  Hidden = 'hidden',
  Visible = 'visible'
}

export type FeaturedCardUpdateInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  expiringAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FeaturedCardStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type Follow = {
  __typename?: 'Follow';
  follower: User;
  following: PrerenderUnion;
  id: Scalars['ID']['output'];
};

export type FollowCreateInput = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<CarouselableEntityEnum>;
  /** use contentId + contentType */
  followingUserId?: InputMaybe<Scalars['ID']['input']>;
};

export enum FreeSharryKind {
  Free = 'free',
  KindOffer = 'kind_offer',
  ResponsiblePrice = 'responsible_price'
}

export type FrontendTranslation = {
  __typename?: 'FrontendTranslation';
  de?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  it?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type FrontendTranslationCreateInput = {
  de?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type FrontendTranslationJsonCreateInput = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FrontendTranslationUpdateInput = {
  de?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type GalleryContent = {
  author?: Maybe<Scalars['String']['output']>;
  copyrightLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  sharryContent?: Maybe<SharryContent>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type GalleryContentCreateEmbedInput = {
  embed?: InputMaybe<Scalars['String']['input']>;
};

export type GalleryContentCreateImageInput = {
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Use this
   *  https://github.com/jaydenseric/graphql-multipart-request-spec
   *  https://sirmuel.design/working-with-file-uploads-using-altair-graphql-d2f86dc8261f
   */
  original?: InputMaybe<Scalars['Upload']['input']>;
  processed?: InputMaybe<Scalars['Upload']['input']>;
  shotAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type GalleryContentCreateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<GalleryContentCreateEmbedInput>;
  image?: InputMaybe<GalleryContentCreateImageInput>;
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  sharryContentId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export enum GalleryContentLicenseEnum {
  Copyrighted = 'copyrighted',
  CreativeCommons = 'creative_commons',
  FreeUse = 'free_use'
}

export type GalleryContentUpdateEmbedInput = {
  embed?: InputMaybe<Scalars['String']['input']>;
};

export type GalleryContentUpdateImageInput = {
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Use this
   *  https://github.com/jaydenseric/graphql-multipart-request-spec
   *  https://sirmuel.design/working-with-file-uploads-using-altair-graphql-d2f86dc8261f
   */
  original?: InputMaybe<Scalars['Upload']['input']>;
  processed?: InputMaybe<Scalars['Upload']['input']>;
  shotAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type GalleryContentUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<GalleryContentUpdateEmbedInput>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<GalleryContentUpdateImageInput>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type GalleryEmbed = GalleryContent & {
  __typename?: 'GalleryEmbed';
  author?: Maybe<Scalars['String']['output']>;
  copyrightLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  embed?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  sharryContent?: Maybe<SharryContent>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type GalleryImage = GalleryContent & {
  __typename?: 'GalleryImage';
  author?: Maybe<Scalars['String']['output']>;
  bestVersion?: Maybe<Image>;
  copyrightLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isCover?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  licenseType?: Maybe<GalleryContentLicenseEnum>;
  longitude?: Maybe<Scalars['Float']['output']>;
  original?: Maybe<Image>;
  processed?: Maybe<Image>;
  sharryContent?: Maybe<SharryContent>;
  shotAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type GalleryImageCreateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Use this
   *  https://github.com/jaydenseric/graphql-multipart-request-spec
   *  https://sirmuel.design/working-with-file-uploads-using-altair-graphql-d2f86dc8261f
   */
  original?: InputMaybe<Scalars['Upload']['input']>;
  processed?: InputMaybe<Scalars['Upload']['input']>;
  sharryContentId: Scalars['ID']['input'];
  shotAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type GiftCard = {
  __typename?: 'GiftCard';
  cardMessage: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveredAt: Scalars['ISO8601DateTime']['output'];
  deliveryMethod?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  receiverName: Scalars['String']['output'];
  residualPrice: Scalars['Float']['output'];
  restrictedToContents?: Maybe<Array<SharryContent>>;
  senderName: Scalars['String']['output'];
  status: GiftCardStatusEnum;
  template: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GiftCardCreateInput = {
  cardMessage: Scalars['Int']['input'];
  deliveredAt: Scalars['ISO8601DateTime']['input'];
  deliveryMethod: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  receiverName: Scalars['String']['input'];
  senderName: Scalars['String']['input'];
  template: Scalars['Int']['input'];
};

export enum GiftCardStatusEnum {
  Active = 'active',
  Created = 'created',
  Expired = 'expired',
  Used = 'used'
}

export type Hashtag = {
  __typename?: 'Hashtag';
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  taggingsCount: Scalars['Int']['output'];
  taggingsCountCommunity?: Maybe<Scalars['Int']['output']>;
  trendingPlace?: Maybe<Scalars['String']['output']>;
  zoom?: Maybe<Scalars['Int']['output']>;
};

export type HashtagCreateInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type HashtagUpdateInput = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type HelpRequestCreateInput = {
  hour: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageProvince = {
  __typename?: 'HomepageProvince';
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HomepageRanking = {
  __typename?: 'HomepageRanking';
  address?: Maybe<Scalars['String']['output']>;
  homepageRankingType?: Maybe<HomepageRankingType>;
  id: Scalars['ID']['output'];
  region?: Maybe<Scalars['String']['output']>;
  sharryContent?: Maybe<SharryContent>;
  sort?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export enum HomepageRankingType {
  LastMonthPlace = 'last_month_place',
  LastMonthUser = 'last_month_user',
  LastMonthWonder = 'last_month_wonder'
}

export type IdSort = {
  __typename?: 'IdSort';
  id: Scalars['ID']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
};

export type IdSortInput = {
  id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type Image = {
  __typename?: 'Image';
  url?: Maybe<Scalars['String']['output']>;
};


export type ImageUrlArgs = {
  convert?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type IndexCreateInput = {
  sharryContentId: Scalars['ID']['input'];
  sharryContentIndexIds: Array<Scalars['ID']['input']>;
  sharryIndexType: Scalars['ID']['input'];
};

export type IndexUpdateInput = {
  id: Scalars['ID']['input'];
  sharryContentId: Scalars['ID']['input'];
  sharryContentIndexIds: Array<Scalars['ID']['input']>;
  sharryIndexType: Scalars['ID']['input'];
};

export type IndicesTypes = {
  __typename?: 'IndicesTypes';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Itinerary = {
  __typename?: 'Itinerary';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  itineraryAltimetry?: Maybe<ItineraryAltimetry>;
  itineraryPoints?: Maybe<Array<ItineraryPoint>>;
  layerLink?: Maybe<Scalars['String']['output']>;
};

export type ItineraryAltimetry = {
  __typename?: 'ItineraryAltimetry';
  difference?: Maybe<Scalars['String']['output']>;
  differenceDown?: Maybe<Scalars['String']['output']>;
  differenceUp?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<ItineraryDifficulty>;
  duration?: Maybe<Scalars['String']['output']>;
  durationBike?: Maybe<Scalars['String']['output']>;
  durationWalk?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  length?: Maybe<Scalars['String']['output']>;
  maxSlm?: Maybe<Scalars['String']['output']>;
  minSlm?: Maybe<Scalars['String']['output']>;
};

export type ItineraryAltimetryInput = {
  difference?: InputMaybe<Scalars['String']['input']>;
  differenceDown?: InputMaybe<Scalars['String']['input']>;
  differenceUp?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<ItineraryDifficulty>;
  duration?: InputMaybe<Scalars['String']['input']>;
  durationBike?: InputMaybe<Scalars['String']['input']>;
  durationWalk?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  maxSlm?: InputMaybe<Scalars['String']['input']>;
  minSlm?: InputMaybe<Scalars['String']['input']>;
};

export type ItineraryCreateInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  layerLink?: InputMaybe<Scalars['String']['input']>;
  sharryContentId: Scalars['ID']['input'];
};

export enum ItineraryDifficulty {
  Easy = 'easy',
  Hard = 'hard',
  Medium = 'medium'
}

export type ItineraryPoint = {
  __typename?: 'ItineraryPoint';
  expandable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  itineraryAltimetry?: Maybe<ItineraryAltimetry>;
  label?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ItineraryPointCreateInput = {
  expandable?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  itineraryId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ItineraryPointUpdateInput = {
  expandable?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ItineraryUpdateInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  layerLink?: InputMaybe<Scalars['String']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ItsaMe {
  /** it's-a not me */
  Luigi = 'Luigi',
  /** it's-a me */
  Mario = 'Mario'
}

export type Keyword = {
  __typename?: 'Keyword';
  id: Scalars['ID']['output'];
  keywordsCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type KeywordCounter = {
  __typename?: 'KeywordCounter';
  count: Scalars['Int']['output'];
  keyword: Scalars['String']['output'];
};

export type Land = {
  __typename?: 'Land';
  accessibility?: Maybe<Array<LandInfo>>;
  advertisements?: Maybe<Array<Advertisement>>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  calendarList?: Maybe<Array<ContentUnion>>;
  calendarListCounters?: Maybe<Array<KeywordCounter>>;
  calendarListKeywords?: Maybe<Array<Scalars['String']['output']>>;
  categories?: Maybe<Array<Category>>;
  centerCoordinates?: Maybe<CoordinatesFields>;
  cherryTransactions?: Maybe<Array<CherryTransaction>>;
  cloudfrontId?: Maybe<Scalars['String']['output']>;
  collaborationImages?: Maybe<Array<Scalars['String']['output']>>;
  collaborationUrls?: Maybe<Array<CollaborationUrls>>;
  collaborations?: Maybe<Array<Collaboration>>;
  contacts?: Maybe<Array<LandInfo>>;
  contents?: Maybe<Array<ContentUnion>>;
  coverPicture?: Maybe<GalleryImage>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deployed?: Maybe<Scalars['Boolean']['output']>;
  deployedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featuredList?: Maybe<Array<ContentUnion>>;
  featuredListCounters?: Maybe<Array<KeywordCounter>>;
  featuredListKeywords?: Maybe<Array<Scalars['String']['output']>>;
  followers?: Maybe<Array<User>>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  galleryContents?: Maybe<Array<LandGalleryImage>>;
  howReach?: Maybe<Array<LandInfo>>;
  id: Scalars['ID']['output'];
  ideal?: Maybe<Array<LandInfo>>;
  image?: Maybe<Image>;
  landContents?: Maybe<Array<LandContent>>;
  landInfos?: Maybe<Array<LandInfo>>;
  landKeywords?: Maybe<Array<LandKeyword>>;
  layerLink?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<Scalars['String']['output']>>;
  metaTag?: Maybe<MetaTag>;
  myFollow?: Maybe<Follow>;
  name?: Maybe<Scalars['String']['output']>;
  param?: Maybe<Scalars['String']['output']>;
  postList?: Maybe<Array<ContentUnion>>;
  sharryContentIds?: Maybe<Array<IdSort>>;
  slug?: Maybe<Scalars['String']['output']>;
  specialDays?: Maybe<Array<LandInfo>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userGoldList?: Maybe<Array<ContentUnion>>;
  userGoldListCounters?: Maybe<Array<KeywordCounter>>;
  userGoldListKeywords?: Maybe<Array<Scalars['String']['output']>>;
  userIds?: Maybe<Array<IdSort>>;
  video?: Maybe<Scalars['String']['output']>;
  visibleAdvertisements?: Maybe<Array<Advertisement>>;
  zoom?: Maybe<Scalars['Int']['output']>;
};


export type LandCalendarListArgs = {
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LandCherryTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LandContentsArgs = {
  filter?: InputMaybe<SearchNode>;
  nearMap?: InputMaybe<NearFilter>;
};


export type LandFeaturedListArgs = {
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LandFollowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LandPostListArgs = {
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LandUserGoldListArgs = {
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LandContent = {
  __typename?: 'LandContent';
  content?: Maybe<ContentUnion>;
  id: Scalars['ID']['output'];
};

export type LandContentMutationInput = {
  contentId: Scalars['ID']['input'];
  landId: Scalars['ID']['input'];
};

export type LandCreateInput = {
  accessibility?: InputMaybe<Array<LandInfoUpdate>>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  centerCoordinates?: InputMaybe<CoordinatesInput>;
  collaborationImages?: InputMaybe<Array<Scalars['String']['input']>>;
  collaborationUrls?: InputMaybe<Array<CollaborationUrlUpdate>>;
  contacts?: InputMaybe<Array<LandInfoUpdate>>;
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featuredListKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  howReach?: InputMaybe<Array<LandInfoUpdate>>;
  ideal?: InputMaybe<Array<LandInfoUpdate>>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  landInfos?: InputMaybe<Array<LandInfoUpdate>>;
  layerLink?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  metaTag?: InputMaybe<MetaTagInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharryContentIds?: InputMaybe<Array<IdSortInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialDays?: InputMaybe<Array<LandInfoUpdate>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userGoldListKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<IdSortInput>>;
  video?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type LandGalleryImage = {
  __typename?: 'LandGalleryImage';
  author?: Maybe<Scalars['String']['output']>;
  bestVersion?: Maybe<Image>;
  copyrightLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCover?: Maybe<Scalars['Boolean']['output']>;
  land?: Maybe<Land>;
  licenseType?: Maybe<GalleryContentLicenseEnum>;
  original?: Maybe<Image>;
  processed?: Maybe<Image>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type LandGalleryImageCreateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<GalleryContentCreateImageInput>;
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  landId?: InputMaybe<Scalars['ID']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type LandGalleryImageUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  processed?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type LandInfo = {
  __typename?: 'LandInfo';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<LandInfoKind>;
  landId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum LandInfoKind {
  Accessibility = 'accessibility',
  Contacts = 'contacts',
  HowReach = 'how_reach',
  Ideal = 'ideal',
  SpecialDays = 'special_days',
  Urls = 'urls'
}

export type LandInfoUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<LandInfoKind>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LandKeyword = {
  __typename?: 'LandKeyword';
  id: Scalars['ID']['output'];
  keyword?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<LandKeywordKind>;
};

export enum LandKeywordKind {
  CalendarListKeyword = 'calendar_list_keyword',
  FeaturedListKeyword = 'featured_list_keyword',
  UserGoldListKeyword = 'user_gold_list_keyword'
}

export type LandSlugValidateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};

export type LandUpdateInput = {
  accessibility?: InputMaybe<Array<LandInfoUpdate>>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  centerCoordinates?: InputMaybe<CoordinatesInput>;
  collaborationImages?: InputMaybe<Array<Scalars['String']['input']>>;
  collaborationUrls?: InputMaybe<Array<CollaborationUrlUpdate>>;
  contacts?: InputMaybe<Array<LandInfoUpdate>>;
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featuredListKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  howReach?: InputMaybe<Array<LandInfoUpdate>>;
  id: Scalars['ID']['input'];
  ideal?: InputMaybe<Array<LandInfoUpdate>>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  landInfos?: InputMaybe<Array<LandInfoUpdate>>;
  layerLink?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  metaTag?: InputMaybe<MetaTagInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharryContentIds?: InputMaybe<Array<IdSortInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  specialDays?: InputMaybe<Array<LandInfoUpdate>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userGoldListKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<IdSortInput>>;
  video?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type LanguageUpdateInput = {
  id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type LastTranslationCommit = {
  __typename?: 'LastTranslationCommit';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type LikeCollection = {
  __typename?: 'LikeCollection';
  categories?: Maybe<Array<Category>>;
  clappers?: Maybe<Array<User>>;
  collectionClaps?: Maybe<Array<CollectionClap>>;
  collectionClapsCount?: Maybe<Scalars['Int']['output']>;
  contentLikes?: Maybe<Array<ContentLike>>;
  contentsCount?: Maybe<Scalars['Int']['output']>;
  coverContent?: Maybe<SharryContent>;
  coverContentUser?: Maybe<User>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customCover?: Maybe<CustomCover>;
  default?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  followers?: Maybe<Array<User>>;
  hasCustomCover?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  likeCollectionContents?: Maybe<Array<LikeCollectionContent>>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  notificationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  param?: Maybe<Scalars['String']['output']>;
  privacySetting?: Maybe<PrivacySetting>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user: User;
};


export type LikeCollectionLikeCollectionContentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LikeCollectionContent = {
  __typename?: 'LikeCollectionContent';
  content?: Maybe<ContentUnion>;
  id: Scalars['ID']['output'];
  likeCollection?: Maybe<LikeCollection>;
};

export type LikeCollectionContentCreateInput = {
  contentId: Scalars['ID']['input'];
  contentType: CarouselableEntityEnum;
  likeCollectionId: Scalars['ID']['input'];
};

export type LikeCollectionContentDeleteInput = {
  contentId: Scalars['ID']['input'];
  contentType: CarouselableEntityEnum;
  likeCollectionId: Scalars['ID']['input'];
};

export type LikeCollectionCreateInput = {
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  privacySetting: PrivacySetting;
  title: Scalars['String']['input'];
};

export type LikeCollectionUpdateInput = {
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coverContentId?: InputMaybe<Scalars['ID']['input']>;
  coverContentUserId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  privacySetting?: InputMaybe<PrivacySetting>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Available locales.
 * Locales can be passed to the backend through the 'Accept Language' header or used as arguments on GraphQL queries, where explicitly supported.
 */
export enum Locale {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

export type LoginBlank = {
  __typename?: 'LoginBlank';
  id: Scalars['ID']['output'];
};

export type MaintenanceSite = {
  __typename?: 'MaintenanceSite';
  deprecate?: Maybe<Scalars['Boolean']['output']>;
  maintenance?: Maybe<Scalars['Boolean']['output']>;
};

export type Message = {
  __typename?: 'Message';
  body?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  messageKind?: Maybe<MessageKind>;
  messagePreview?: Maybe<MessagePreview>;
  previousMessageSameSender?: Maybe<Scalars['Boolean']['output']>;
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sender?: Maybe<User>;
};

export type MessageCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  receiverId?: InputMaybe<Scalars['ID']['input']>;
  skipPreview?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MessageKind {
  Chat = 'chat',
  CustomRequestAccepted = 'custom_request_accepted',
  CustomRequestAcceptedByClient = 'custom_request_accepted_by_client',
  CustomRequestCancelled = 'custom_request_cancelled',
  CustomRequestCreated = 'custom_request_created',
  CustomRequestExpired = 'custom_request_expired',
  CustomRequestModified = 'custom_request_modified',
  CustomRequestPaid = 'custom_request_paid',
  CustomRequestRejected = 'custom_request_rejected'
}

export type MessagePreview = {
  __typename?: 'MessagePreview';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  imageHeight?: Maybe<Scalars['String']['output']>;
  imageType?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MetaTag = {
  __typename?: 'MetaTag';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MetaTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Month = {
  __typename?: 'Month';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminAccessibilityCategoryCreate?: Maybe<AccessibilityCategory>;
  adminAccessibilityCategoryDelete?: Maybe<AccessibilityCategory>;
  adminAccessibilityCategoryUpdate?: Maybe<AccessibilityCategory>;
  adminBackofficeSharryContentItemCreate?: Maybe<BackofficeSharryContentItem>;
  adminBackofficeSharryContentItemDelete?: Maybe<BackofficeSharryContentItem>;
  adminBackofficeSharryContentItemUpdate?: Maybe<BackofficeSharryContentItem>;
  adminCategoryCreate?: Maybe<Category>;
  adminCategoryDelete?: Maybe<Category>;
  adminCategoryUpdate?: Maybe<Category>;
  adminCollaborationCreate?: Maybe<Collaboration>;
  adminCollaborationDelete?: Maybe<Collaboration>;
  adminCollaborationKindCreate?: Maybe<CollaborationKind>;
  adminCollaborationKindDelete?: Maybe<CollaborationKind>;
  adminCollaborationKindUpdate?: Maybe<CollaborationKind>;
  adminCollaborationUpdate?: Maybe<Collaboration>;
  adminContentCarouselCreate?: Maybe<ContentCarousel>;
  adminContentCarouselDelete?: Maybe<ContentCarousel>;
  adminContentCarouselEntityCreate?: Maybe<ContentCarousel>;
  adminContentCarouselEntityDelete?: Maybe<ContentCarousel>;
  adminContentCarouselEntityUpdate?: Maybe<ContentCarousel>;
  adminContentCarouselUpdate?: Maybe<ContentCarousel>;
  adminImageCacheInvalidate?: Maybe<OperationReturn>;
  adminLanguageCreate?: Maybe<Language>;
  adminLanguageDelete?: Maybe<Language>;
  adminLanguageUpdate?: Maybe<Language>;
  adminLikeCollectionUpdate?: Maybe<LikeCollection>;
  adminNetworkCreate?: Maybe<Network>;
  adminNetworkDelete?: Maybe<Network>;
  adminNetworkUpdate?: Maybe<Network>;
  adminPaymentUpdate?: Maybe<Payment>;
  /** Create recommendation from post */
  adminPostToRecommendation?: Maybe<Wonder>;
  adminQualificationCreate?: Maybe<Qualification>;
  adminQualificationDelete?: Maybe<Qualification>;
  adminQualificationUpdate?: Maybe<Qualification>;
  adminRecommendationUnpublish?: Maybe<Wonder>;
  adminRecommendationUpdate?: Maybe<Wonder>;
  /** Validate a recommendation and generate a new wonder */
  adminRecommendationValidate?: Maybe<SharryContent>;
  adminRefundAmountUpdate?: Maybe<Refund>;
  adminSearchBannerCreate?: Maybe<SearchBanner>;
  adminSearchBannerDelete?: Maybe<SearchBanner>;
  adminSearchBannerUpdate?: Maybe<SearchBanner>;
  adminServiceCreate?: Maybe<Service>;
  adminServiceDelete?: Maybe<Service>;
  adminServiceUpdate?: Maybe<Service>;
  /** Publish a wonder, event or resource */
  adminSharryContentPublish?: Maybe<SharryContent>;
  /** Reject recommendations and sharries. */
  adminSharryContentReject?: Maybe<SharryContent>;
  adminSharryContentValidatorNotesUpdate?: Maybe<SharryContent>;
  /** Change any SharryContent visibility. */
  adminSharryContentVisibleUpdate?: Maybe<SharryContent>;
  adminSharryKindCreate?: Maybe<SharryKind>;
  adminSharryKindDelete?: Maybe<SharryKind>;
  adminSharryKindUpdate?: Maybe<SharryKind>;
  adminSharrylandConfigUpdate?: Maybe<SharrylandConfig>;
  adminSuggestedSearchCreate?: Maybe<SuggestedSearch>;
  adminSuggestedSearchDelete?: Maybe<SuggestedSearch>;
  adminSuggestedSearchUpdate?: Maybe<SuggestedSearch>;
  adminTranslateAllMissingFields?: Maybe<OperationReturn>;
  /** Admin and dev only, argument is optional, if not present tries to confirm current user. Don't expect this to work in production. */
  adminUserConfirmEmail?: Maybe<User>;
  adminUserCreate?: Maybe<User>;
  adminUserDelete?: Maybe<User>;
  adminUserUpdate?: Maybe<User>;
  adminVisitDurationCreate?: Maybe<VisitDuration>;
  adminVisitDurationDelete?: Maybe<VisitDuration>;
  adminVisitDurationUpdate?: Maybe<VisitDuration>;
  /** Update wrongdoing report status and assign admin_id */
  adminWrongdoingReportUpdate?: Maybe<WrongdoingReport>;
  advertisementCreate?: Maybe<Advertisement>;
  advertisementDelete?: Maybe<Advertisement>;
  advertisementUpdate?: Maybe<Advertisement>;
  analyticGoogleMapCreate?: Maybe<AnalyticGoogleMap>;
  /** This mutation is used in maintence ambient. PAY ATTENTION! */
  analyticSessionCreate?: Maybe<AnalyticSession>;
  /** This mutation is used in maintence ambient. PAY ATTENTION! */
  analyticSessionKill?: Maybe<AnalyticSession>;
  /** This mutation is used in maintence ambient. PAY ATTENTION! */
  analyticSessionPageCreate?: Maybe<AnalyticSessionPage>;
  analyticSessionUpdate?: Maybe<AnalyticSession>;
  analyticWidgetCreate?: Maybe<AnalyticWidget>;
  attachedDocumentCreate?: Maybe<AttachedDocument>;
  attachedDocumentDelete?: Maybe<AttachedDocument>;
  attachedDocumentUpdate?: Maybe<AttachedDocument>;
  behalfOfUserCartCreate?: Maybe<BehalfOfUserCart>;
  behalfOfUserCartDelete?: Maybe<BehalfOfUserCart>;
  behalfOfUserCartUpdate?: Maybe<BehalfOfUserCart>;
  blockContent?: Maybe<OperationReturn>;
  cartCreate?: Maybe<Cart>;
  cartItemCreate?: Maybe<CartItem>;
  cartItemDelete?: Maybe<CartItem>;
  cartItemRefundRequest?: Maybe<CartItem>;
  cartItemStatusUpdate?: Maybe<CartItem>;
  cartItemUpdate?: Maybe<CartItem>;
  cartUpdate?: Maybe<Cart>;
  changeContentCreator?: Maybe<SharryContent>;
  changeContentOwner?: Maybe<SharryContent>;
  cherryDiscountRedeem?: Maybe<CherryDiscount>;
  cherryDiscountValidate?: Maybe<CherryDiscount>;
  collaborationCreate?: Maybe<Collaboration>;
  collaborationDelete?: Maybe<Collaboration>;
  collectionClapCreate?: Maybe<CollectionClap>;
  collectionClapDelete?: Maybe<CollectionClap>;
  confirmDirectUpload?: Maybe<OperationReturn>;
  connectedAccountCreate?: Maybe<Scalars['String']['output']>;
  contentFavouriteCreate?: Maybe<ContentFavourite>;
  contentFavouriteDelete?: Maybe<ContentFavourite>;
  contentIndexCreate?: Maybe<SharryContentIndex>;
  contentIndexDelete?: Maybe<SharryContentIndex>;
  contentIndexUpdate?: Maybe<SharryContentIndex>;
  contentLikeAddCollection?: Maybe<LikeCollection>;
  contentLikeCreate?: Maybe<ContentLike>;
  contentLikeDelete?: Maybe<ContentLike>;
  contentLikeRemoveCollection?: Maybe<LikeCollection>;
  conversationCreate?: Maybe<Conversation>;
  conversationGroupCreate?: Maybe<Conversation>;
  conversationGroupDelete?: Maybe<Conversation>;
  conversationGroupJoin?: Maybe<Conversation>;
  conversationGroupLeave?: Maybe<Conversation>;
  conversationGroupUpdate?: Maybe<Conversation>;
  conversationLeave?: Maybe<Conversation>;
  conversationRead?: Maybe<Conversation>;
  cookiePreferenceCreate?: Maybe<CookiePreference>;
  cookiePreferenceDelete?: Maybe<CookiePreference>;
  cookiePreferenceUpdate?: Maybe<CookiePreference>;
  coordinatorApplication?: Maybe<OperationReturn>;
  createDirectUpload?: Maybe<CreateDirectUploadPayload>;
  customCoverCreate?: Maybe<CustomCover>;
  customCoverDelete?: Maybe<GalleryContent>;
  customCoverUpdate?: Maybe<CustomCover>;
  customLinkCreate?: Maybe<CustomLink>;
  customLinkDelete?: Maybe<CustomLink>;
  customLinkUpdate?: Maybe<CustomLink>;
  customNotificationCreate?: Maybe<CustomNotification>;
  customNotificationDelete?: Maybe<CustomNotification>;
  customNotificationSend?: Maybe<CustomNotification>;
  customNotificationUpdate?: Maybe<CustomNotification>;
  customVariantCreate?: Maybe<SharryVariant>;
  draftRecommendationDelete?: Maybe<Wonder>;
  draftRecommendationUpdate?: Maybe<Wonder>;
  draftSharryDelete?: Maybe<Sharry>;
  draftSharryUpdate?: Maybe<Sharry>;
  eventCreate?: Maybe<Event>;
  eventDelete?: Maybe<Event>;
  eventInstanceCreate?: Maybe<EventInstance>;
  eventInstanceDelete?: Maybe<EventInstance>;
  eventInstanceUpdate?: Maybe<EventInstance>;
  eventUpdate?: Maybe<Event>;
  faqBodyCreate?: Maybe<FaqBody>;
  faqBodyDelete?: Maybe<FaqBody>;
  faqCreate?: Maybe<Faq>;
  faqDelete?: Maybe<Faq>;
  faqSectionCreate?: Maybe<FaqSection>;
  faqSectionDelete?: Maybe<FaqSection>;
  faqUpdate?: Maybe<Faq>;
  featuredCardCreate?: Maybe<FeaturedCard>;
  featuredCardDelete?: Maybe<FeaturedCard>;
  featuredCardUpdate?: Maybe<FeaturedCard>;
  followCreate?: Maybe<Follow>;
  followDelete?: Maybe<Follow>;
  frontendTranslationCreate?: Maybe<FrontendTranslation>;
  frontendTranslationDelete?: Maybe<FrontendTranslation>;
  frontendTranslationJsonCreate?: Maybe<OperationReturn>;
  frontendTranslationUpdate?: Maybe<FrontendTranslation>;
  galleryContentCreate?: Maybe<GalleryContent>;
  galleryContentDelete?: Maybe<GalleryContent>;
  galleryContentUpdate?: Maybe<GalleryContent>;
  galleryImageCreate?: Maybe<GalleryContent>;
  giftCardCreate?: Maybe<GiftCard>;
  giftCardValidate?: Maybe<GiftCard>;
  goldSubscriptionCreate?: Maybe<PaymentIntentData>;
  goldSubscriptionDelete?: Maybe<OperationReturn>;
  hashtagCreate?: Maybe<Hashtag>;
  hashtagDelete?: Maybe<Hashtag>;
  hashtagUpdate?: Maybe<Hashtag>;
  helpRequestCreate?: Maybe<OperationReturn>;
  invalidateCache?: Maybe<OperationReturn>;
  itineraryCreate?: Maybe<Itinerary>;
  itineraryDelete?: Maybe<Itinerary>;
  itineraryPointCreate?: Maybe<ItineraryPoint>;
  itineraryPointDelete?: Maybe<ItineraryPoint>;
  itineraryPointUpdate?: Maybe<ItineraryPoint>;
  itineraryUpdate?: Maybe<Itinerary>;
  landContentMutation?: Maybe<OperationReturn>;
  landCreate?: Maybe<Land>;
  landDelete?: Maybe<Land>;
  landGalleryImageCreate?: Maybe<LandGalleryImage>;
  landGalleryImageDelete?: Maybe<LandGalleryImage>;
  landGalleryImageUpdate?: Maybe<LandGalleryImage>;
  landSlugValidate?: Maybe<OperationReturn>;
  landUpdate?: Maybe<Land>;
  likeCollectionContentCreate?: Maybe<LikeCollection>;
  likeCollectionContentDelete?: Maybe<LikeCollection>;
  likeCollectionCreate?: Maybe<LikeCollection>;
  likeCollectionDelete?: Maybe<LikeCollection>;
  likeCollectionNotify?: Maybe<LikeCollection>;
  likeCollectionUpdate?: Maybe<LikeCollection>;
  messageCreate?: Maybe<Message>;
  notificationCartItemRead?: Maybe<Notification>;
  notificationRead?: Maybe<Notification>;
  notificationReadAll?: Maybe<OperationReturn>;
  notifyContactsRequest?: Maybe<OperationReturn>;
  ownerContentClapCreate?: Maybe<OwnerContentClap>;
  ownerContentClapDelete?: Maybe<OwnerContentClap>;
  paymentIntentConfirm?: Maybe<OperationReturn>;
  paymentIntentCreate?: Maybe<PaymentIntentData>;
  paymentIntentFail?: Maybe<OperationReturn>;
  paymentIntentUpdate?: Maybe<OperationReturn>;
  pnrrCreate?: Maybe<Pnrr>;
  pnrrDelete?: Maybe<Pnrr>;
  pnrrUpdate?: Maybe<Pnrr>;
  postCreate?: Maybe<Post>;
  postDelete?: Maybe<Post>;
  postUpdate?: Maybe<Post>;
  /** @deprecated Use InvalidateCache */
  publicEventUpdate?: Maybe<Event>;
  /** @deprecated Use InvalidateCache */
  publicSharryUpdate?: Maybe<Sharry>;
  /** @deprecated Use InvalidateCache */
  publicWonderUpdate?: Maybe<Wonder>;
  publishedSharryUpdate?: Maybe<Sharry>;
  recipeCreate?: Maybe<Recipe>;
  recipeDelete?: Maybe<Recipe>;
  recipeUpdate?: Maybe<Recipe>;
  recommendationCreate?: Maybe<Wonder>;
  recommendationPublish?: Maybe<Wonder>;
  refundCreate?: Maybe<Refund>;
  refundManage?: Maybe<CartItem>;
  refundPictureCreate?: Maybe<RefundPicture>;
  refundPictureDelete?: Maybe<RefundPicture>;
  sharryContentAccessibilityCategoryCreate?: Maybe<SharryContentAccessibilityCategory>;
  sharryContentAccessibilityCategoryDelete?: Maybe<SharryContentAccessibilityCategory>;
  sharryContentAccessibilityCategoryUpdate?: Maybe<SharryContentAccessibilityCategory>;
  sharryContentAdvertisementCreate?: Maybe<Advertisement>;
  sharryContentAdvertisementDelete?: Maybe<Advertisement>;
  sharryContentAdvertisementUpdate?: Maybe<Advertisement>;
  sharryContentChangeStatus?: Maybe<SharryContent>;
  sharryCreate?: Maybe<Sharry>;
  sharryPublish?: Maybe<Sharry>;
  sharryReviewAddAnswer?: Maybe<SharryReview>;
  sharryReviewClapCreate?: Maybe<ReviewClap>;
  sharryReviewClapDelete?: Maybe<ReviewClap>;
  sharryReviewCreate?: Maybe<SharryReview>;
  sharryReviewDelete?: Maybe<SharryReview>;
  sharryReviewPictureCreate?: Maybe<SharryReviewPicture>;
  sharryReviewPictureDelete?: Maybe<SharryReviewPicture>;
  sharryReviewUpdate?: Maybe<SharryReview>;
  shippingCreate?: Maybe<Shipping>;
  shippingDelete?: Maybe<Shipping>;
  shippingUpdate?: Maybe<Shipping>;
  transferManage?: Maybe<Transfer>;
  translationRequest?: Maybe<OperationReturn>;
  unblockContent?: Maybe<OperationReturn>;
  userAcceptPrivacyPolicy?: Maybe<User>;
  userAcceptTermsAndConditions?: Maybe<User>;
  userAnonymise?: Maybe<User>;
  userBlockUser?: Maybe<OperationReturn>;
  userChangeEmailConfirm?: Maybe<User>;
  userChangeEmailRequest?: Maybe<User>;
  userChangeFavouriteCurrency?: Maybe<User>;
  userChangeFavouriteLanguage?: Maybe<User>;
  userChangePassword?: Maybe<User>;
  userConfirmationCode?: Maybe<User>;
  userDeleteSearches?: Maybe<User>;
  userDeviceCreate?: Maybe<Device>;
  userDeviceDelete?: Maybe<Device>;
  userGalleryImageCreate?: Maybe<UserGalleryImage>;
  userGalleryImageDelete?: Maybe<UserGalleryImage>;
  userGalleryImageUpdate?: Maybe<UserGalleryImage>;
  userReferralMask?: Maybe<User>;
  userReportCreate?: Maybe<UserReport>;
  userRequestData?: Maybe<OperationReturn>;
  userResendConfirmationEmail?: Maybe<OperationReturn>;
  userResetPassword?: Maybe<UserSignIn>;
  userResetPasswordRequest?: Maybe<OperationReturn>;
  userSearchCreate?: Maybe<UserSearch>;
  userShopInfoConfirmedUpdate?: Maybe<OperationReturn>;
  userSignIn?: Maybe<UserSignIn>;
  userSignOut?: Maybe<User>;
  userSignUp?: Maybe<UserSignIn>;
  userUnblockUser?: Maybe<OperationReturn>;
  userUpdate?: Maybe<User>;
  userVisitPage?: Maybe<OperationReturn>;
  variantStatusUpdate?: Maybe<SharryVariant>;
  wonderUpdate?: Maybe<SharryContent>;
  wrongdoingReportCreate?: Maybe<WrongdoingReport>;
};


export type MutationAdminAccessibilityCategoryCreateArgs = {
  input: AccessibilityCategoryInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminAccessibilityCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminAccessibilityCategoryUpdateArgs = {
  input: AccessibilityCategoryUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminBackofficeSharryContentItemCreateArgs = {
  input: AdminBackofficeSharryContentItemCreateInput;
};


export type MutationAdminBackofficeSharryContentItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminBackofficeSharryContentItemUpdateArgs = {
  input: AdminBackofficeSharryContentItemUpdateInput;
};


export type MutationAdminCategoryCreateArgs = {
  input: CategoryInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCategoryUpdateArgs = {
  input: CategoryUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminCollaborationCreateArgs = {
  input: AdminCollaborationCreateInput;
};


export type MutationAdminCollaborationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCollaborationKindCreateArgs = {
  input: CollaborationKindCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminCollaborationKindDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCollaborationKindUpdateArgs = {
  input: CollaborationKindUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminCollaborationUpdateArgs = {
  input: AdminCollaborationUpdateInput;
};


export type MutationAdminContentCarouselCreateArgs = {
  input: ContentCarouselCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminContentCarouselDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminContentCarouselEntityCreateArgs = {
  input: ContentCarouselEntityCreateInput;
};


export type MutationAdminContentCarouselEntityDeleteArgs = {
  contentCarouselId: Scalars['ID']['input'];
  contentId: Scalars['ID']['input'];
  contentType: CarouselableEntityEnum;
};


export type MutationAdminContentCarouselEntityUpdateArgs = {
  input: ContentCarouselEntityUpdateInput;
};


export type MutationAdminContentCarouselUpdateArgs = {
  input: ContentCarouselUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminImageCacheInvalidateArgs = {
  urls: Array<Scalars['String']['input']>;
};


export type MutationAdminLanguageCreateArgs = {
  input: AdminLanguageInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminLanguageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminLanguageUpdateArgs = {
  input: LanguageUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminLikeCollectionUpdateArgs = {
  input: AdminLikeCollectionUpdateInput;
};


export type MutationAdminNetworkCreateArgs = {
  input: NetworkCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminNetworkDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminNetworkUpdateArgs = {
  input: NetworkUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminPaymentUpdateArgs = {
  input: AdminPaymentUpdateInput;
};


export type MutationAdminPostToRecommendationArgs = {
  input: AdminPostToRecommendationInput;
};


export type MutationAdminQualificationCreateArgs = {
  input: AdminQualificationInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminQualificationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminQualificationUpdateArgs = {
  input: AdminQualificationUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminRecommendationUnpublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRecommendationUpdateArgs = {
  input: AdminRecommendationUpdateInput;
};


export type MutationAdminRecommendationValidateArgs = {
  input: RecommendationValidateInput;
};


export type MutationAdminRefundAmountUpdateArgs = {
  id: Scalars['ID']['input'];
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAdminSearchBannerCreateArgs = {
  input: SearchBannerCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminSearchBannerDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSearchBannerUpdateArgs = {
  input: SearchBannerUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminServiceCreateArgs = {
  input: ServiceInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminServiceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminServiceUpdateArgs = {
  input: ServiceUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminSharryContentPublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSharryContentRejectArgs = {
  id: Scalars['ID']['input'];
  validatorNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSharryContentValidatorNotesUpdateArgs = {
  input: AdminSharryContentValidatorNotesInput;
};


export type MutationAdminSharryContentVisibleUpdateArgs = {
  input: AdminSharryContentVisibleUpdateInput;
};


export type MutationAdminSharryKindCreateArgs = {
  input: AdminSharryKindInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminSharryKindDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSharryKindUpdateArgs = {
  input: AdminSharryKindUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminSharrylandConfigUpdateArgs = {
  input: AdminSharrylandConfigUpdateInput;
};


export type MutationAdminSuggestedSearchCreateArgs = {
  input: SuggestedSearchInput;
};


export type MutationAdminSuggestedSearchDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSuggestedSearchUpdateArgs = {
  input: SuggestedSearchInput;
};


export type MutationAdminUserConfirmEmailArgs = {
  input?: InputMaybe<UserConfirmEmailInput>;
};


export type MutationAdminUserCreateArgs = {
  input: AdminUserCreateInput;
};


export type MutationAdminUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUserUpdateArgs = {
  input: AdminUserUpdateInput;
};


export type MutationAdminVisitDurationCreateArgs = {
  input: VisitDurationInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminVisitDurationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminVisitDurationUpdateArgs = {
  input: VisitDurationUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdminWrongdoingReportUpdateArgs = {
  input: AdminWrongdoingReportUpdateInput;
};


export type MutationAdvertisementCreateArgs = {
  input: AdvertisementCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAdvertisementDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdvertisementUpdateArgs = {
  input: AdvertisementUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationAnalyticGoogleMapCreateArgs = {
  input: AnalyticGoogleMapCreateInput;
};


export type MutationAnalyticSessionCreateArgs = {
  input: AnalyticSessionCreateInput;
};


export type MutationAnalyticSessionKillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAnalyticSessionPageCreateArgs = {
  input: AnalyticSessionPageCreateInput;
};


export type MutationAnalyticSessionUpdateArgs = {
  input: AnalyticSessionUpdateInput;
};


export type MutationAnalyticWidgetCreateArgs = {
  input: AnalyticWidgetCreateInput;
};


export type MutationAttachedDocumentCreateArgs = {
  input: AttachedDocumentCreateInput;
};


export type MutationAttachedDocumentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAttachedDocumentUpdateArgs = {
  input: AttachedDocumentUpdateInput;
};


export type MutationBehalfOfUserCartCreateArgs = {
  input: BehalfOfUserCartCreateInput;
};


export type MutationBehalfOfUserCartDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBehalfOfUserCartUpdateArgs = {
  input: BehalfOfUserCartUpdateInput;
};


export type MutationBlockContentArgs = {
  input: BlockContentInput;
};


export type MutationCartCreateArgs = {
  input: CartCreateInput;
};


export type MutationCartItemCreateArgs = {
  input: CartItemCreateInput;
};


export type MutationCartItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCartItemRefundRequestArgs = {
  asOwner: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: RefundReason;
  request: RefundRequest;
  shippingArrival?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type MutationCartItemStatusUpdateArgs = {
  input: CartItemStatusUpdateInput;
};


export type MutationCartItemUpdateArgs = {
  input: CartItemUpdateInput;
};


export type MutationCartUpdateArgs = {
  input: CartUpdateInput;
};


export type MutationChangeContentCreatorArgs = {
  creatorId: Scalars['ID']['input'];
  sharryContentId: Scalars['ID']['input'];
};


export type MutationChangeContentOwnerArgs = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  sharryContentId: Scalars['ID']['input'];
};


export type MutationCherryDiscountRedeemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCherryDiscountValidateArgs = {
  code: Scalars['String']['input'];
};


export type MutationCollaborationCreateArgs = {
  input: CollaborationCreateInput;
};


export type MutationCollaborationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCollectionClapCreateArgs = {
  input: CollectionClapCreateInput;
};


export type MutationCollectionClapDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmDirectUploadArgs = {
  input: ConfirmDirectUploadInput;
};


export type MutationContentFavouriteCreateArgs = {
  input: ContentFavouriteCreateInput;
};


export type MutationContentFavouriteDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContentIndexCreateArgs = {
  input: IndexCreateInput;
};


export type MutationContentIndexDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContentIndexUpdateArgs = {
  input: IndexUpdateInput;
};


export type MutationContentLikeAddCollectionArgs = {
  input: ContentLikeAddCollectionInput;
};


export type MutationContentLikeCreateArgs = {
  input: ContentLikeCreateInput;
};


export type MutationContentLikeDeleteArgs = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<CarouselableEntityEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationContentLikeRemoveCollectionArgs = {
  input: ContentLikeRemoveCollectionInput;
};


export type MutationConversationCreateArgs = {
  input: ConversationCreateInput;
};


export type MutationConversationGroupCreateArgs = {
  input: ConversationGroupCreateInput;
};


export type MutationConversationGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConversationGroupJoinArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConversationGroupLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConversationGroupUpdateArgs = {
  input: ConversationGroupUpdateInput;
};


export type MutationConversationLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConversationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCookiePreferenceCreateArgs = {
  input: CookiePreferenceCreateInput;
};


export type MutationCookiePreferenceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCookiePreferenceUpdateArgs = {
  input: CookiePreferenceUpdateInput;
};


export type MutationCoordinatorApplicationArgs = {
  input: CoordinatorApplicationInput;
};


export type MutationCreateDirectUploadArgs = {
  input: CreateDirectUploadInput;
};


export type MutationCustomCoverCreateArgs = {
  input: CustomCoverCreateInput;
};


export type MutationCustomCoverDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomCoverUpdateArgs = {
  input: CustomCoverUpdateInput;
};


export type MutationCustomLinkCreateArgs = {
  input: CustomLinkCreateInput;
};


export type MutationCustomLinkDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomLinkUpdateArgs = {
  input: CustomLinkUpdateInput;
};


export type MutationCustomNotificationCreateArgs = {
  input: CustomNotificationCreateInput;
};


export type MutationCustomNotificationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomNotificationSendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomNotificationUpdateArgs = {
  input: CustomNotificationUpdateInput;
};


export type MutationCustomVariantCreateArgs = {
  input: SharryVariantInput;
  sharryContentId: Scalars['ID']['input'];
};


export type MutationDraftRecommendationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftRecommendationUpdateArgs = {
  input: DraftRecommendationUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationDraftSharryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftSharryUpdateArgs = {
  input: DraftSharryUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationEventCreateArgs = {
  input: EventCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationEventDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEventInstanceCreateArgs = {
  input: EventInstanceCreateInput;
};


export type MutationEventInstanceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEventInstanceUpdateArgs = {
  input: EventInstanceUpdateInput;
};


export type MutationEventUpdateArgs = {
  input: EventUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationFaqBodyCreateArgs = {
  input: FaqBodyCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationFaqBodyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFaqCreateArgs = {
  input: FaqCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationFaqDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFaqSectionCreateArgs = {
  input: FaqSectionCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationFaqSectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFaqUpdateArgs = {
  faqBodyInput?: InputMaybe<FaqBodyUpdateInput>;
  faqInput?: InputMaybe<FaqUpdateInput>;
  faqSectionInput?: InputMaybe<FaqSectionUpdateInput>;
  locale?: InputMaybe<Locale>;
};


export type MutationFeaturedCardCreateArgs = {
  input: FeaturedCardCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationFeaturedCardDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFeaturedCardUpdateArgs = {
  input: FeaturedCardUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationFollowCreateArgs = {
  input: FollowCreateInput;
};


export type MutationFollowDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFrontendTranslationCreateArgs = {
  input: FrontendTranslationCreateInput;
};


export type MutationFrontendTranslationDeleteArgs = {
  key: Scalars['String']['input'];
};


export type MutationFrontendTranslationJsonCreateArgs = {
  input: FrontendTranslationJsonCreateInput;
};


export type MutationFrontendTranslationUpdateArgs = {
  input: FrontendTranslationUpdateInput;
};


export type MutationGalleryContentCreateArgs = {
  input: GalleryContentCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationGalleryContentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGalleryContentUpdateArgs = {
  input: GalleryContentUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationGalleryImageCreateArgs = {
  input: GalleryImageCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationGiftCardCreateArgs = {
  cartUuid?: InputMaybe<Scalars['String']['input']>;
  input: GiftCardCreateInput;
};


export type MutationGiftCardValidateArgs = {
  code: Scalars['String']['input'];
};


export type MutationGoldSubscriptionCreateArgs = {
  billingInfoInput?: InputMaybe<BillingInfoInput>;
};


export type MutationHashtagCreateArgs = {
  input: HashtagCreateInput;
};


export type MutationHashtagDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationHashtagUpdateArgs = {
  input: HashtagUpdateInput;
};


export type MutationHelpRequestCreateArgs = {
  input: HelpRequestCreateInput;
};


export type MutationInvalidateCacheArgs = {
  mediaPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationItineraryCreateArgs = {
  altimetryInput?: InputMaybe<ItineraryAltimetryInput>;
  input: ItineraryCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationItineraryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationItineraryPointCreateArgs = {
  altimetryInput?: InputMaybe<ItineraryAltimetryInput>;
  input: ItineraryPointCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationItineraryPointDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationItineraryPointUpdateArgs = {
  altimetryInput?: InputMaybe<ItineraryAltimetryInput>;
  input?: InputMaybe<ItineraryPointUpdateInput>;
  locale?: InputMaybe<Locale>;
};


export type MutationItineraryUpdateArgs = {
  altimetryInput?: InputMaybe<ItineraryAltimetryInput>;
  input?: InputMaybe<ItineraryUpdateInput>;
  locale?: InputMaybe<Locale>;
};


export type MutationLandContentMutationArgs = {
  input: LandContentMutationInput;
};


export type MutationLandCreateArgs = {
  input: LandCreateInput;
};


export type MutationLandDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandGalleryImageCreateArgs = {
  input: LandGalleryImageCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationLandGalleryImageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandGalleryImageUpdateArgs = {
  input: LandGalleryImageUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationLandSlugValidateArgs = {
  input: LandSlugValidateInput;
};


export type MutationLandUpdateArgs = {
  input: LandUpdateInput;
};


export type MutationLikeCollectionContentCreateArgs = {
  input: LikeCollectionContentCreateInput;
};


export type MutationLikeCollectionContentDeleteArgs = {
  input: LikeCollectionContentDeleteInput;
};


export type MutationLikeCollectionCreateArgs = {
  input: LikeCollectionCreateInput;
};


export type MutationLikeCollectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLikeCollectionNotifyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLikeCollectionUpdateArgs = {
  input: LikeCollectionUpdateInput;
};


export type MutationMessageCreateArgs = {
  input: MessageCreateInput;
};


export type MutationNotificationCartItemReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyContactsRequestArgs = {
  input: NotifyContactsRequestInput;
};


export type MutationOwnerContentClapCreateArgs = {
  input: OwnerContentClapCreateInput;
};


export type MutationOwnerContentClapDeleteArgs = {
  clapId: Scalars['ID']['input'];
};


export type MutationPaymentIntentConfirmArgs = {
  billingInfo: BillingInfoInput;
  saveFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
  shippingInfo?: InputMaybe<ShippingInfoInput>;
  shopOrderId: Scalars['ID']['input'];
};


export type MutationPaymentIntentCreateArgs = {
  behalfOfUserCart?: InputMaybe<Scalars['Boolean']['input']>;
  cartUuid?: InputMaybe<Scalars['String']['input']>;
  cherryDiscountCode?: InputMaybe<Scalars['String']['input']>;
  giftcardCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPaymentIntentFailArgs = {
  paymentIntentId: Scalars['ID']['input'];
};


export type MutationPaymentIntentUpdateArgs = {
  paymentIntentId: Scalars['ID']['input'];
  paymentMethodType: Scalars['String']['input'];
};


export type MutationPnrrCreateArgs = {
  input: PnrrCreateInput;
};


export type MutationPnrrDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPnrrUpdateArgs = {
  input: PnrrUpdateInput;
};


export type MutationPostCreateArgs = {
  input: PostCreateInput;
};


export type MutationPostDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPostUpdateArgs = {
  input: PostUpdateInput;
};


export type MutationPublicEventUpdateArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationPublicSharryUpdateArgs = {
  sharryId: Scalars['ID']['input'];
};


export type MutationPublicWonderUpdateArgs = {
  wonderId: Scalars['ID']['input'];
};


export type MutationPublishedSharryUpdateArgs = {
  input: PublishedSharryUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationRecipeCreateArgs = {
  input: RecipeCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationRecipeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecipeUpdateArgs = {
  input?: InputMaybe<RecipeUpdateInput>;
  locale?: InputMaybe<Locale>;
};


export type MutationRecommendationCreateArgs = {
  input: RecommendationCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationRecommendationPublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefundCreateArgs = {
  input: RefundCreateInput;
};


export type MutationRefundManageArgs = {
  acceptRefund: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRefundPictureCreateArgs = {
  image: Scalars['Upload']['input'];
  refundId: Scalars['ID']['input'];
};


export type MutationRefundPictureDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSharryContentAccessibilityCategoryCreateArgs = {
  input: SharryContentAccessibilityCategoryCreateInput;
};


export type MutationSharryContentAccessibilityCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSharryContentAccessibilityCategoryUpdateArgs = {
  input: SharryContentAccessibilityCategoryUpdateInput;
};


export type MutationSharryContentAdvertisementCreateArgs = {
  input: SharryContentAdvertisementCreateInput;
};


export type MutationSharryContentAdvertisementDeleteArgs = {
  input: SharryContentAdvertisementDeleteInput;
};


export type MutationSharryContentAdvertisementUpdateArgs = {
  input: SharryContentAdvertisementUpdateInput;
};


export type MutationSharryContentChangeStatusArgs = {
  id: Scalars['ID']['input'];
  status: SharryContentStatus;
};


export type MutationSharryCreateArgs = {
  input: SharryCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationSharryPublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSharryReviewAddAnswerArgs = {
  answer: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSharryReviewClapCreateArgs = {
  input: SharryReviewClapCreateInput;
};


export type MutationSharryReviewClapDeleteArgs = {
  clapId: Scalars['ID']['input'];
};


export type MutationSharryReviewCreateArgs = {
  input: SharryReviewCreateInput;
};


export type MutationSharryReviewDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSharryReviewPictureCreateArgs = {
  input: SharryReviewPictureCreateInput;
};


export type MutationSharryReviewPictureDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSharryReviewUpdateArgs = {
  input: SharryReviewUpdateInput;
};


export type MutationShippingCreateArgs = {
  input: ShippingCreateInput;
};


export type MutationShippingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShippingUpdateArgs = {
  input: ShippingUpdateInput;
};


export type MutationTransferManageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTranslationRequestArgs = {
  input: TranslationRequestInput;
};


export type MutationUnblockContentArgs = {
  input: UnblockContentInput;
};


export type MutationUserBlockUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserChangeEmailConfirmArgs = {
  input: UserChangeEmailConfirmInput;
};


export type MutationUserChangeEmailRequestArgs = {
  input: UserChangeEmailRequestInput;
};


export type MutationUserChangeFavouriteCurrencyArgs = {
  input: UserChangeFavouriteCurrencyInput;
};


export type MutationUserChangeFavouriteLanguageArgs = {
  input: UserChangeFavouriteLanguageInput;
};


export type MutationUserChangePasswordArgs = {
  input: UserChangePasswordInput;
};


export type MutationUserConfirmationCodeArgs = {
  input: UserConfirmationCodeInput;
};


export type MutationUserDeviceCreateArgs = {
  input: DeviceInput;
};


export type MutationUserDeviceDeleteArgs = {
  token: Scalars['String']['input'];
};


export type MutationUserGalleryImageCreateArgs = {
  input: UserGalleryImageCreateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationUserGalleryImageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserGalleryImageUpdateArgs = {
  input: UserGalleryImageUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationUserReferralMaskArgs = {
  input: UserReferralMaskInput;
};


export type MutationUserReportCreateArgs = {
  input: UserReportInput;
};


export type MutationUserResetPasswordArgs = {
  input: UserResetPasswordInput;
};


export type MutationUserResetPasswordRequestArgs = {
  input: UserResetPasswordRequestInput;
};


export type MutationUserSearchCreateArgs = {
  input: UserSearchCreateInput;
};


export type MutationUserSignInArgs = {
  input: SignInInput;
};


export type MutationUserSignUpArgs = {
  input: SignUpInput;
};


export type MutationUserUnblockUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationUserVisitPageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVariantStatusUpdateArgs = {
  id: Scalars['ID']['input'];
  status: SharryVariantStatus;
};


export type MutationWonderUpdateArgs = {
  input: WonderUpdateInput;
  locale?: InputMaybe<Locale>;
};


export type MutationWrongdoingReportCreateArgs = {
  input: WrongdoingReportCreateInput;
};

export type NearFilter = {
  activeId?: InputMaybe<Scalars['ID']['input']>;
  activeType?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Coordinates>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type Network = {
  __typename?: 'Network';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Image>;
  longDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<ContentOwner>;
  subscribers?: Maybe<Array<ContentOwner>>;
  zoom?: Maybe<Scalars['Int']['output']>;
};

export type NetworkCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type NetworkUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<NotificationKind>;
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reference?: Maybe<NotificationReference>;
  secondaryReference?: Maybe<NotificationReference>;
};

export type NotificationFeed = {
  __typename?: 'NotificationFeed';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<ContentUnion>;
  referenceKind?: Maybe<ReferenceKind>;
  threshold?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export enum NotificationKind {
  AppleLoginBlankName = 'apple_login_blank_name',
  BebValidated = 'beb_validated',
  CartItemAccepted = 'cart_item_accepted',
  CartItemCreateOwner = 'cart_item_create_owner',
  CartItemCreateUser = 'cart_item_create_user',
  CartItemPaidOwner = 'cart_item_paid_owner',
  CartItemPaidUser = 'cart_item_paid_user',
  CartItemRejected = 'cart_item_rejected',
  ContentApproved = 'content_approved',
  ContentNewHeart = 'content_new_heart',
  CustomNotification = 'custom_notification',
  CustomRequestAcceptedByClientOwner = 'custom_request_accepted_by_client_owner',
  CustomRequestAcceptedClient = 'custom_request_accepted_client',
  CustomRequestCancelledClient = 'custom_request_cancelled_client',
  CustomRequestCreatedOwner = 'custom_request_created_owner',
  CustomRequestModifiedClient = 'custom_request_modified_client',
  CustomRequestRejectedClient = 'custom_request_rejected_client',
  Editorial = 'editorial',
  ExpiredCustomRequestClient = 'expired_custom_request_client',
  ExpiredCustomRequestOwner = 'expired_custom_request_owner',
  Follow = 'follow',
  FollowBecamePro = 'follow_became_pro',
  FollowReferral = 'follow_referral',
  JoinGroup = 'join_group',
  NewCollaboratedSharry = 'new_collaborated_sharry',
  NewCollectionByFollowed = 'new_collection_by_followed',
  NewRecommendationByFollowed = 'new_recommendation_by_followed',
  NewSharryByFollowed = 'new_sharry_by_followed',
  NewSharryInstanceByFollowed = 'new_sharry_instance_by_followed',
  NewSharryPicture = 'new_sharry_picture',
  NewSharryReview = 'new_sharry_review',
  NewUser = 'new_user',
  NewWallMessage = 'new_wall_message',
  PaymentFailed = 'payment_failed',
  PostSharryReview = 'post_sharry_review',
  ProGoldWelcome = 'pro_gold_welcome',
  ProWelcome = 'pro_welcome',
  ProfileNewHeart = 'profile_new_heart',
  RecommendationCreate = 'recommendation_create',
  RecommendationRejected = 'recommendation_rejected',
  RecommendationUnpublished = 'recommendation_unpublished',
  ReviewNewClap = 'review_new_clap',
  Sharry_15Before = 'sharry_15_before',
  SharryBebSelfSubscribe = 'sharry_beb_self_subscribe',
  SharryBebSubscribe = 'sharry_beb_subscribe',
  SharryClientUnsubscribe = 'sharry_client_unsubscribe',
  SharryDayBefore = 'sharry_day_before',
  SharryFeedback = 'sharry_feedback',
  SharryInstanceCancelled = 'sharry_instance_cancelled',
  SharryLeaveComment = 'sharry_leave_comment',
  SharryOwnerSuspended = 'sharry_owner_suspended',
  SharryReminder = 'sharry_reminder',
  SharryReviewReply = 'sharry_review_reply',
  SharrySelfSubscribe = 'sharry_self_subscribe',
  SharrySubscribe = 'sharry_subscribe',
  SharrySuspended = 'sharry_suspended',
  SharryTimeChange = 'sharry_time_change',
  SharryUnsubscribe = 'sharry_unsubscribe',
  SharryUnsubscribeCustomRequest = 'sharry_unsubscribe_custom_request',
  SharryValidated = 'sharry_validated',
  SharryWelcome = 'sharry_welcome',
  TaggedPost = 'tagged_post',
  TaggedSharryReview = 'tagged_sharry_review',
  UnansweredCustomRequest = 'unanswered_custom_request',
  UnpaidCustomRequest = 'unpaid_custom_request',
  UnpaidCustomRequestOwner = 'unpaid_custom_request_owner',
  UpcomingSharryUpdated = 'upcoming_sharry_updated',
  UpdateApp = 'update_app',
  UserCherryGoal = 'user_cherry_goal',
  UserDeleteBooking = 'user_delete_booking'
}

/** Entities that can be attached to a notification */
export type NotificationReference = BecomePro | CartItem | Conversation | CustomNotification | Event | LikeCollection | LoginBlank | Post | Sharry | SharryReview | User | UserCherryGoal | Wonder;

export type NotifyContactsRequestInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  request: ContactsRequest;
  role: ContactsRole;
  surname: Scalars['String']['input'];
};

export type OperationReturn = {
  __typename?: 'OperationReturn';
  success?: Maybe<OperationReturnTypeEnum>;
};

export enum OperationReturnTypeEnum {
  Ko = 'ko',
  Ok = 'ok'
}

export type OwnerContentClap = {
  __typename?: 'OwnerContentClap';
  id: Scalars['ID']['output'];
  sharryContent: SharryContent;
  user: User;
};

export type OwnerContentClapCreateInput = {
  sharryContentId: Scalars['ID']['input'];
};

export type PageCount = {
  __typename?: 'PageCount';
  count?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
};

export type PageTime = {
  __typename?: 'PageTime';
  count?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  applicationFee?: Maybe<Scalars['Float']['output']>;
  billingInfo?: Maybe<BillingInfo>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  partiallyRefundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentIntentDescription?: Maybe<Scalars['String']['output']>;
  paymentKind?: Maybe<PaymentKind>;
  recipientUser?: Maybe<User>;
  refundedAmount: Scalars['Float']['output'];
  refundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  resource?: Maybe<PaymentResource>;
  shippingInfo?: Maybe<ShippingInfo>;
  status: PaymentStatus;
  stripeUid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type PaymentIntentData = {
  __typename?: 'PaymentIntentData';
  clientSecret?: Maybe<Scalars['String']['output']>;
  freeUid?: Maybe<Scalars['String']['output']>;
  payment: Payment;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  publishableKey: Scalars['String']['output'];
  shopOrder: ShopOrder;
};

export enum PaymentKind {
  GoldRenewal = 'gold_renewal',
  GoldSubscription = 'gold_subscription',
  SharryAttendance = 'sharry_attendance',
  ShopOrder = 'shop_order'
}

/** Entities that can be paid */
export type PaymentResource = ShopOrder | User;

export enum PaymentStatus {
  Cancelled = 'cancelled',
  Incomplete = 'incomplete',
  PaymentFailed = 'payment_failed',
  RefundFailed = 'refund_failed',
  RefundPending = 'refund_pending',
  Refunded = 'refunded',
  Succeeded = 'succeeded'
}

export enum PersonKind {
  LegalPerson = 'legal_person',
  NaturalPerson = 'natural_person'
}

export type Place = {
  __typename?: 'Place';
  id: Scalars['ID']['output'];
  isMunicipality?: Maybe<Scalars['Boolean']['output']>;
  isProvince?: Maybe<Scalars['Boolean']['output']>;
  isRegion?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type PlaceUtility = {
  __typename?: 'PlaceUtility';
  createdAt: Scalars['ISO8601DateTime']['output'];
  distance?: Maybe<Scalars['Int']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  googleMapsUri?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Place>;
  placeType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Pnrr = {
  __typename?: 'Pnrr';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  sharryContentId?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PnrrCreateInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  sharryContentId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PnrrUpdateInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  sharryContentId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Post = SharryContent & {
  __typename?: 'Post';
  accessibilityCategories?: Maybe<Array<SharryContentAccessibilityCategory>>;
  address?: Maybe<Scalars['String']['output']>;
  advertisements?: Maybe<Array<Advertisement>>;
  attachedDocuments?: Maybe<Array<AttachedDocument>>;
  audio?: Maybe<Scalars['String']['output']>;
  audioDuration?: Maybe<Scalars['Float']['output']>;
  audioSignature?: Maybe<Scalars['String']['output']>;
  audioSignatureDuration?: Maybe<Scalars['Float']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Category>>;
  clappers?: Maybe<Array<User>>;
  clappingReviewCount?: Maybe<Scalars['Int']['output']>;
  collaborations?: Maybe<Array<Collaboration>>;
  communityTags?: Maybe<Array<Hashtag>>;
  contentCarousels?: Maybe<Array<ContentCarousel>>;
  contentFavourites?: Maybe<Array<ContentFavourite>>;
  contentLikes?: Maybe<Array<ContentLike>>;
  contentType?: Maybe<Scalars['String']['output']>;
  coverPicture?: Maybe<GalleryImage>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<ContentOwner>;
  curatedRelatedSharryContents?: Maybe<Array<SharryContent>>;
  customCover?: Maybe<CustomCover>;
  customProvince?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  eventRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  followers?: Maybe<Array<User>>;
  galleryContents?: Maybe<Array<GalleryContent>>;
  /** @deprecated Use gallery contents PLS */
  galleryImages?: Maybe<Array<GalleryImage>>;
  genericContact?: Maybe<Scalars['String']['output']>;
  geographicallyRelatedContents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedEvents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharries?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharrylanders?: Maybe<Array<UserSearchResult>>;
  geographicallyRelatedWonders?: Maybe<Array<SharryContent>>;
  hasCustomCover?: Maybe<Scalars['Boolean']['output']>;
  hashtags?: Maybe<Array<Hashtag>>;
  id: Scalars['ID']['output'];
  imTheOwner?: Maybe<Scalars['Boolean']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  isRecommendation?: Maybe<Scalars['Boolean']['output']>;
  isShadowBanned?: Maybe<Scalars['Boolean']['output']>;
  itineraryNew?: Maybe<Itinerary>;
  keywords?: Maybe<Array<Keyword>>;
  landIds?: Maybe<Array<Scalars['ID']['output']>>;
  lastCommentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mapPicture?: Maybe<Image>;
  metaTag?: Maybe<MetaTag>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  notes?: Maybe<Scalars['String']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  originalTitle?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<ContentOwner>;
  ownerContentClaps?: Maybe<Array<OwnerContentClap>>;
  ownerContentClapsCount?: Maybe<Scalars['Int']['output']>;
  paladinUrls?: Maybe<Array<CollaborationUrls>>;
  param?: Maybe<Scalars['String']['output']>;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom cover. */
  pictureCollageAsCover?: Maybe<Scalars['Boolean']['output']>;
  pnrr?: Maybe<Scalars['Boolean']['output']>;
  pnrrContent?: Maybe<Pnrr>;
  posterImage?: Maybe<Scalars['JSON']['output']>;
  postsRelated?: Maybe<Array<SharryContent>>;
  postsRelatedCount?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recipeNew?: Maybe<Array<Recipe>>;
  region?: Maybe<Scalars['String']['output']>;
  requiresBooking?: Maybe<Scalars['Boolean']['output']>;
  requiresPayment?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<Array<SharryReview>>;
  searchableAddress?: Maybe<Scalars['String']['output']>;
  seasons?: Maybe<Array<SeasonEnum>>;
  sharryContentsIds?: Maybe<Array<Scalars['ID']['output']>>;
  sharryDiscounts?: Maybe<Array<SharryDiscount>>;
  sharryIndex?: Maybe<Array<SharryContentIndices>>;
  sharryKind?: Maybe<SharryKind>;
  sharryRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  sharrySelection?: Maybe<SharrySelection>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCustomCarousels?: Maybe<Scalars['Boolean']['output']>;
  showDirections?: Maybe<Scalars['Boolean']['output']>;
  showMaps?: Maybe<Scalars['Boolean']['output']>;
  showRelatedCarousels?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  staticMap?: Maybe<Image>;
  status: SharryContentStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedTime?: Maybe<Scalars['String']['output']>;
  taggedUsersIds?: Maybe<Array<Scalars['ID']['output']>>;
  telephone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  totalReviewCount?: Maybe<Scalars['Int']['output']>;
  unpublishedReviews?: Maybe<Array<SharryReview>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  validatorNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated visibility is deprecated. Use suspended/adminHidden status instead. */
  visible?: Maybe<Scalars['Boolean']['output']>;
  visibleAdvertisements?: Maybe<Array<Advertisement>>;
  visitDuration?: Maybe<VisitDuration>;
  website?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  wizardSeenSteps?: Maybe<Array<Scalars['String']['output']>>;
  wonderRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
};


export type PostLandIdsArgs = {
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PostPostsRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PostCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  communityTagList?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  landIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  sharryContentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  taggedUsersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PostUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  communityTagList?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  landIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  sharryContentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SharryContentStatus>;
  taggedUsersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PrerenderUnion = Category | Event | Land | Post | SearchBanner | Sharry | User | Wonder;

export type PrivacyPolicyVersion = {
  __typename?: 'PrivacyPolicyVersion';
  cookies?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum PrivacySetting {
  PrivacyOpen = 'privacy_open',
  PrivacyReserved = 'privacy_reserved'
}

export type PublishedSharryUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  animalsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  availableForBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  availableForBusinessSort?: InputMaybe<Scalars['Int']['input']>;
  badWeatherInfo?: InputMaybe<Scalars['String']['input']>;
  bebDescription?: InputMaybe<Scalars['String']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  covid19Info?: InputMaybe<Scalars['String']['input']>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  customRequestsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customRequestsWeekdays?: InputMaybe<Array<SharryWeekdays>>;
  deliveryTime?: InputMaybe<Scalars['Int']['input']>;
  /** It's deprecated BRAH */
  description?: InputMaybe<Scalars['String']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  freeSharryKind?: InputMaybe<FreeSharryKind>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  invoicesRequestsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  involvedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineHelper?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoEmbedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  itinerary?: InputMaybe<Scalars['JSON']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  maxAttendants?: InputMaybe<Scalars['Int']['input']>;
  meetingLocation?: InputMaybe<Scalars['String']['input']>;
  meetingLocationLatitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLocationLongitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLocationNotes?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  minAttendants?: InputMaybe<Scalars['Int']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<SharryContentOwnerType>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  pictureCollageAsCover?: InputMaybe<Scalars['Boolean']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  practicalInfo?: InputMaybe<Scalars['String']['input']>;
  pricePerChild?: InputMaybe<Scalars['Float']['input']>;
  pricePerPerson?: InputMaybe<Scalars['Float']['input']>;
  /** Admin only */
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  reducedMobility?: InputMaybe<Scalars['Boolean']['input']>;
  reducedMobilityNotes?: InputMaybe<Scalars['String']['input']>;
  refundable?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  responseTime?: InputMaybe<Scalars['Int']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  servicesSharryContents?: InputMaybe<Array<ServicesSharryContentsInput>>;
  sharryDiscounts?: InputMaybe<Array<SharryDiscountInput>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  sharryVariants?: InputMaybe<Array<SharryVariantInput>>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  showDirections?: InputMaybe<Scalars['Boolean']['input']>;
  showMaps?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  soldBySharryland?: InputMaybe<Scalars['Boolean']['input']>;
  splitAgeVariant?: InputMaybe<Scalars['Boolean']['input']>;
  startingPrice?: InputMaybe<Scalars['Float']['input']>;
  startingPriceKind?: InputMaybe<StartingPriceKind>;
  startingPriceNotes?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unlimitedAttendants?: InputMaybe<Scalars['Boolean']['input']>;
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  validatorNotes?: InputMaybe<Scalars['String']['input']>;
  variantDuration?: InputMaybe<VariantDurationInput>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatToBring?: InputMaybe<Scalars['String']['input']>;
  whatWeWillDo?: InputMaybe<Scalars['String']['input']>;
  whatWeWillDoAttachment?: InputMaybe<ContentCreateAttachedDocumentInput>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Qualification = {
  __typename?: 'Qualification';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  requiresCertification?: Maybe<Scalars['Boolean']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  usersCount?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Find an accessibility category by id */
  accessibilityCategory?: Maybe<AccessibilityCategory>;
  /** Returns all cherry discounts, Dev and Admin only */
  adminAllCherryDiscounts?: Maybe<Array<CherryDiscount>>;
  adminAllCollaborationKinds?: Maybe<Array<CollaborationKind>>;
  /** Returns all gift cards, Dev and Admin only */
  adminAllGiftCards?: Maybe<Array<GiftCard>>;
  /** Returns all collections, Dev and Admin only */
  adminAllLikeCollections?: Maybe<Array<LikeCollection>>;
  /** Returns all payments, Dev and Admin only */
  adminAllPayments?: Maybe<Array<Payment>>;
  /** Returns all refund, Dev and Admin only */
  adminAllRefunds?: Maybe<Array<Refund>>;
  /** Returns all transfers, Dev and Admin only */
  adminAllTransfers?: Maybe<Array<Transfer>>;
  /** Returns all user reports, Dev and Admin only */
  adminAllUserReports?: Maybe<Array<UserReport>>;
  /** Returns all users, Dev and Admin only */
  adminAllUsers?: Maybe<Array<User>>;
  /** Returns all wrongdoing reports, Dev and Admin only */
  adminAllWrongdoingReports?: Maybe<Array<WrongdoingReport>>;
  advertisement?: Maybe<Advertisement>;
  allAccessibilityCategories?: Maybe<Array<AccessibilityCategory>>;
  allAdvertisement?: Maybe<Array<Advertisement>>;
  /** return all analytics */
  allAnalytics?: Maybe<Array<Analytic>>;
  /** all backoffice sharry content item */
  allBackofficeSharryContentItem?: Maybe<Array<BackofficeSharryContentItem>>;
  allCategories?: Maybe<Array<Category>>;
  allCollaborationKinds?: Maybe<Array<CollaborationKind>>;
  /** all conversations for current user */
  allConversations?: Maybe<Array<Conversation>>;
  allCurrencyCodes?: Maybe<Array<ExchangeCurrency>>;
  /** all custom links */
  allCustomLinks?: Maybe<Array<CustomLink>>;
  allCustomNotification?: Maybe<Array<CustomNotification>>;
  allEventInstances?: Maybe<Array<EventInstance>>;
  /** all events */
  allEvents?: Maybe<Array<Event>>;
  /** all faqs */
  allFaqs?: Maybe<Array<Faq>>;
  allFeaturedCard?: Maybe<Array<FeaturedCard>>;
  /** Returns all translations */
  allFrontendTranslations?: Maybe<Array<FrontendTranslation>>;
  allHashtags?: Maybe<Array<Hashtag>>;
  /** homepage ranking all */
  allHomepageRanking?: Maybe<Array<HomepageRanking>>;
  allKeywords?: Maybe<Array<Keyword>>;
  /** return all lands */
  allLands?: Maybe<Array<Land>>;
  /** retrieve all languages */
  allLanguages?: Maybe<Array<Language>>;
  allMonths?: Maybe<Array<Month>>;
  allNetworks?: Maybe<Array<Network>>;
  /** all notifications for current user */
  allNotifications?: Maybe<Array<Notification>>;
  allOwnerCartItems?: Maybe<Array<CartItem>>;
  allOwnerCartItemsCalendar?: Maybe<Array<CartItem>>;
  allPayments?: Maybe<Array<Payment>>;
  /** return all place utilities */
  allPlaceUtilities?: Maybe<Array<PlaceUtility>>;
  /** all posts and notification feeds */
  allPosts?: Maybe<Array<CommunityPost>>;
  allQualifications?: Maybe<Array<Qualification>>;
  /** all recommendations, requires user */
  allRecommendations?: Maybe<Array<Wonder>>;
  /** all review changes by id */
  allReviewChanges?: Maybe<Array<SharryReviewChange>>;
  allReviews?: Maybe<Array<SharryReview>>;
  allSearchBanners?: Maybe<Array<SearchBanner>>;
  allSearchableContents?: Maybe<Array<SearchableContent>>;
  allServices?: Maybe<Array<Service>>;
  allSharries?: Maybe<Array<Sharry>>;
  allSharryContents?: Maybe<Array<SharryContent>>;
  allSharryKind?: Maybe<Array<SharryKind>>;
  allUserCartItems?: Maybe<Array<CartItem>>;
  /** Returns all users */
  allUsers?: Maybe<Array<User>>;
  allVisitDurations?: Maybe<Array<VisitDuration>>;
  /** all wonders */
  allWonders?: Maybe<Array<Wonder>>;
  /** find analytic by id */
  analytic?: Maybe<Analytic>;
  /** get analytic stats */
  analyticStats?: Maybe<AnalyticStats>;
  /** widget analytic by time */
  analyticWidgetsByTime?: Maybe<Array<AnalyticWidget>>;
  /** widget analytics by token */
  analyticWidgetsByToken?: Maybe<Array<AnalyticWidget>>;
  /** find analytics by ip address */
  analyticsByIp?: Maybe<Array<Analytic>>;
  /** attached documents by id */
  attachedDocuments?: Maybe<AttachedDocument>;
  /** autocomplete hashtags */
  autocompleteHashtags?: Maybe<Array<Hashtag>>;
  /** autocomplete no places */
  autocompleteNoPlaces?: Maybe<Array<AutocompleteNoPlaces>>;
  /** autocomplete places */
  autocompletePlaces?: Maybe<Array<Place>>;
  /**
   * Text is searched within every content in the platform, all hashtags and cities, provided by google places search.
   *  The places search can be biased by filling longitude and latitude of the point you want to bias the results to.
   * You will have to retrieve the actual coordinates for the places using autocompleteRetrievePlaceCoordinates
   */
  autocompleteSearch?: Maybe<Array<AutocompleteSearchResult>>;
  /**
   * Text is searched within every content in the platform, all hashtags and cities, provided by google places search.
   *  The places search can be biased by filling longitude and latitude of the point you want to bias the results to.
   * You will have to retrieve the actual coordinates for the places using autocompleteRetrievePlaceCoordinates
   */
  autocompleteSearchNew?: Maybe<Array<AutocompleteSearchResult>>;
  /** autocomplete sharries */
  autocompleteSharries?: Maybe<Array<Sharry>>;
  /** autocomplete sharry contents */
  autocompleteSharryContents?: Maybe<Array<SharryContent>>;
  /** autocomplete users places */
  autocompleteUsersPlaces?: Maybe<Array<AutocompleteSearchResult>>;
  /** average page visit time */
  averagePageVisitTime?: Maybe<AveragePageVisitTime>;
  /** average page visits */
  averagePageVisits?: Maybe<AveragePageVisit>;
  /** sharry content by id */
  backofficeSharryContentItem?: Maybe<BackofficeSharryContentItem>;
  /** bounce rate */
  bounceRate?: Maybe<BounceRate>;
  /** Find a cart by uuid */
  cartByUuid?: Maybe<Cart>;
  /** Find a cartItem by id */
  cartItem?: Maybe<CartItem>;
  cartItemPayment?: Maybe<Payment>;
  /** Find a category by id */
  category?: Maybe<Category>;
  /** Find a category by normalized_name */
  categoryByNormalizedName?: Maybe<Category>;
  /** Users search + Current user groups search */
  chatsSearch?: Maybe<Array<ChatUnion>>;
  contentIndexBySharryId?: Maybe<Array<WonderIndex>>;
  /** Find a conversation by ID */
  conversation?: Maybe<Conversation>;
  /** Find a cookie pref by uuid. This query is used in maintence ambient. PAY ATTENTION! */
  cookiePreferenceByUuid?: Maybe<CookiePreference>;
  /** Returns latitude and longitude by address */
  coordinatesByAddress?: Maybe<CoordinatesFields>;
  /** Find a custom link by slug */
  customLinkBySlug?: Maybe<CustomLink>;
  /** custom notification by Id */
  customNotification?: Maybe<CustomNotification>;
  /** faq by id */
  faq?: Maybe<Faq>;
  /** faq by slug */
  faqBySlug?: Maybe<Faq>;
  faqSearch?: Maybe<Array<FaqBody>>;
  /** faq section by slug */
  faqSectionBySlug?: Maybe<FaqSection>;
  featuredCard?: Maybe<FeaturedCard>;
  fileExif?: Maybe<Exif>;
  /** Find a gift card by code */
  giftCardByCode?: Maybe<GiftCard>;
  hashtagSearch?: Maybe<Array<Hashtag>>;
  /** homepage provinces */
  homepageProvinces?: Maybe<Array<HomepageProvince>>;
  /** homepage ranking */
  homepageRanking?: Maybe<Random>;
  /** autocomplete keywords */
  keywordAutocompleteSearch?: Maybe<Array<Keyword>>;
  /** find land by id */
  land?: Maybe<Land>;
  /** Find a land by slug */
  landBySlug?: Maybe<Land>;
  /** get land keywords */
  landKeywords?: Maybe<Array<KeywordCounter>>;
  /** all translations */
  landTranslations?: Maybe<Translation>;
  /**  find a language by id */
  language?: Maybe<Language>;
  /** last translations commit */
  lastTranslationsCommit?: Maybe<LastTranslationCommit>;
  /** latest public contents */
  latestPublicContents?: Maybe<Array<SharryContent>>;
  /** latest visits */
  latestVisits?: Maybe<Array<SharryContent>>;
  /** like collection by id */
  likeCollection?: Maybe<LikeCollection>;
  /** Find a like collection by slug */
  likeCollectionBySlug?: Maybe<LikeCollection>;
  /** like collections by followed */
  likeCollectionsByFollowed?: Maybe<Array<LikeCollection>>;
  /** like collections promoted */
  likeCollectionsPromoted?: Maybe<Array<LikeCollection>>;
  maintenanceSite?: Maybe<MaintenanceSite>;
  /** current user */
  me?: Maybe<User>;
  notificationFeed?: Maybe<Array<NotificationFeed>>;
  /** Find behalf of carts */
  ownerBehalfOfCarts?: Maybe<Array<BehalfOfUserCart>>;
  /** find payment intent by id */
  paymentIntent?: Maybe<PaymentIntentData>;
  placeUtility?: Maybe<PlaceUtility>;
  pnrrContentBySharryId?: Maybe<Pnrr>;
  prerenderEntities?: Maybe<Array<PrerenderUnion>>;
  previewOpenGraph?: Maybe<Scalars['JSON']['output']>;
  /** Returns current privacy policy. This query is used in maintence ambient. PAY ATTENTION! */
  privacyPolicy?: Maybe<PrivacyPolicyVersion>;
  /**
   * sharry content by slug
   * @deprecated Use SharryContentBySlug
   */
  publicSharryContentBySlug?: Maybe<SharryContent>;
  qualification?: Maybe<Qualification>;
  randomSharryContents?: Maybe<Random>;
  recaptcha?: Maybe<OperationReturn>;
  /** Users for community */
  recommendedUsers?: Maybe<Array<User>>;
  /** review by id */
  review?: Maybe<SharryReview>;
  /** routes translations */
  routesTranslations?: Maybe<Array<FrontendTranslation>>;
  /** search banner by input, use only one */
  searchBanner?: Maybe<SearchBanner>;
  /** Returns current selling conditions. This query is used in maintence ambient. PAY ATTENTION! */
  sellingConditions?: Maybe<SellingConditionsVersion>;
  /** Find a service by id */
  service?: Maybe<Service>;
  settings?: Maybe<SharrylandConfig>;
  /** sharry content by id */
  sharryContent?: Maybe<SharryContent>;
  /** retrieve all attached documents of a sharry content */
  sharryContentAttachedDocuments?: Maybe<Array<AttachedDocument>>;
  sharryContentAvailableForBusiness?: Maybe<Array<Sharry>>;
  /** sharry content by slug */
  sharryContentBySlug?: Maybe<SharryContent>;
  sharryIndexTypes?: Maybe<Array<IndicesTypes>>;
  sharrylandCherries?: Maybe<Scalars['Int']['output']>;
  stripeBillingPortal?: Maybe<Scalars['String']['output']>;
  /** all Suggested Searches */
  suggestedSearches?: Maybe<Array<SuggestedSearch>>;
  /** autocomplete tags */
  tagAutocompleteSearch?: Maybe<Array<ContentUnion>>;
  /** users for cos'è SharryLand */
  teamUsers?: Maybe<Array<User>>;
  /** Returns current terms and conditions. This query is used in maintence ambient. PAY ATTENTION! */
  termsAndConditions?: Maybe<TermsAndConditionsVersion>;
  /** top 10 visited urls */
  top10Urls?: Maybe<Scalars['JSON']['output']>;
  /**
   * all translations
   * @deprecated use all_frontend_translations
   */
  translations?: Maybe<Translation>;
  /** upcoming sharries */
  upcomingSharries?: Maybe<Array<Sharry>>;
  /** Find a user by id */
  user?: Maybe<User>;
  /** Find a user by email */
  userByEmail?: Maybe<User>;
  /** Find a user by slug */
  userBySlug?: Maybe<User>;
  /** all cherry goals for current user */
  userCherryGoals?: Maybe<Array<UserCherryGoal>>;
  userSearches?: Maybe<Array<UserSearch>>;
  /** users search */
  usersSearch?: Maybe<Array<User>>;
  /** check variant availability */
  variantAvailability: Scalars['Boolean']['output'];
  /** Find a visit duration by id */
  visitDuration?: Maybe<VisitDuration>;
  /** visitors counts */
  visitorsCount?: Maybe<Visitor>;
  weather?: Maybe<Weather>;
};


export type QueryAccessibilityCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminAllCherryDiscountsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllGiftCardsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllLikeCollectionsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllPaymentsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllRefundsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllTransfersArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllUserReportsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllUsersArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdminAllWrongdoingReportsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAdvertisementArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
};


export type QueryAllAccessibilityCategoriesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllAdvertisementArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllAnalyticsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllBackofficeSharryContentItemArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllCategoriesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  frequencySort?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllConversationsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  withMessages?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllCustomLinksArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllCustomNotificationArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllEventInstancesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllEventsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllFaqsArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryAllFeaturedCardArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllFrontendTranslationsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllHashtagsArgs = {
  communityTags?: InputMaybe<Scalars['Boolean']['input']>;
  communityTagsRanking?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
  tagsRanking?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllHomepageRankingArgs = {
  filter?: InputMaybe<SearchNode>;
};


export type QueryAllKeywordsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllLandsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllLanguagesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllMonthsArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryAllNetworksArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllOwnerCartItemsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllOwnerCartItemsCalendarArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRange>;
  filter?: InputMaybe<SearchNode>;
};


export type QueryAllPlaceUtilitiesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllPostsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  noNotificationFeeds?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAtSort?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllQualificationsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllRecommendationsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllReviewChangesArgs = {
  sharryReviewId: Scalars['ID']['input'];
};


export type QueryAllReviewsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  highlightedId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllSearchBannersArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllSearchableContentsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  nearMap?: InputMaybe<NearFilter>;
  nextDateOrder?: InputMaybe<Scalars['Boolean']['input']>;
  reorder?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  soldBySharryland?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortFilter>;
  titleFirst?: InputMaybe<Scalars['String']['input']>;
  withNoDates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllServicesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllSharriesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  followedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasReviews?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  soldBySharryland?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortFilter>;
  sortByPrice?: InputMaybe<Scalars['String']['input']>;
  titleFirst?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSharryContentsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  followedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hasReviews?: InputMaybe<Scalars['Boolean']['input']>;
  includePosts?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
  titleFirst?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSharryKindArgs = {
  filter?: InputMaybe<SearchNode>;
  locale?: InputMaybe<Locale>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllUserCartItemsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllUsersArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBlockedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllVisitDurationsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAllWondersArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  near?: InputMaybe<NearFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryAnalyticArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticStatsArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticWidgetsByTimeArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
};


export type QueryAnalyticWidgetsByTokenArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
  token: Scalars['String']['input'];
};


export type QueryAnalyticsByIpArgs = {
  ipAddress: Scalars['String']['input'];
};


export type QueryAttachedDocumentsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutocompleteHashtagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  minTaggingsCount?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompleteNoPlacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompletePlacesArgs = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompleteSearchArgs = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompleteSearchNewArgs = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompleteSharriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompleteSharryContentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAutocompleteUsersPlacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryAveragePageVisitTimeArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAveragePageVisitsArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBackofficeSharryContentItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBounceRateArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartByUuidArgs = {
  behalfOfUserCart?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCartItemPaymentArgs = {
  cartItemId: Scalars['ID']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCategoryByNormalizedNameArgs = {
  normalizedName: Scalars['String']['input'];
};


export type QueryChatsSearchArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentIndexBySharryIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversationArgs = {
  allConversations?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryCookiePreferenceByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCoordinatesByAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryCustomLinkBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCustomNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFaqArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
};


export type QueryFaqBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFaqSearchArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  order?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryFaqSectionBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFeaturedCardArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
};


export type QueryFileExifArgs = {
  file: Scalars['Upload']['input'];
};


export type QueryGiftCardByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryHashtagSearchArgs = {
  communityTags?: InputMaybe<Scalars['Boolean']['input']>;
  communityTagsRanking?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
  tagsRanking?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryKeywordAutocompleteSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QueryLandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryLandKeywordsArgs = {
  landId: Scalars['ID']['input'];
};


export type QueryLanguageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLatestPublicContentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLikeCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLikeCollectionBySlugArgs = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryMaintenanceSiteArgs = {
  platform: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QueryNotificationFeedArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryOwnerBehalfOfCartsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryPaymentIntentArgs = {
  freeUid?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlaceUtilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPnrrContentBySharryIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPrerenderEntitiesArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryPreviewOpenGraphArgs = {
  url: Scalars['String']['input'];
};


export type QueryPrivacyPolicyArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryPublicSharryContentBySlugArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale>;
  slug: Scalars['String']['input'];
};


export type QueryQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecaptchaArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchBannerArgs = {
  input: SearchBannerInput;
};


export type QuerySellingConditionsArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharryContentArgs = {
  fallbackTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
};


export type QuerySharryContentAttachedDocumentsArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharryContentAvailableForBusinessArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySharryContentBySlugArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale>;
  slug: Scalars['String']['input'];
};


export type QuerySuggestedSearchesArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipSearch?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFilter>;
};


export type QueryTagAutocompleteSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Locale>;
  text: Scalars['String']['input'];
};


export type QueryTeamUsersArgs = {
  relation: Scalars['String']['input'];
};


export type QueryTermsAndConditionsArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryTop10UrlsArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
};


export type QueryUpcomingSharriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserBySlugArgs = {
  locale?: InputMaybe<Locale>;
  slug: Scalars['String']['input'];
};


export type QueryUserCherryGoalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitSearch?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersSearchArgs = {
  hasPosts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QueryVariantAvailabilityArgs = {
  cartUuid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeCart?: InputMaybe<Scalars['Boolean']['input']>;
  quantity: Scalars['Int']['input'];
  total: Scalars['Int']['input'];
};


export type QueryVisitDurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVisitorsCountArgs = {
  beginsAt: Scalars['ISO8601DateTime']['input'];
  endsAt: Scalars['ISO8601DateTime']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWeatherArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type QueryNode = {
  comparator: SearchComparator;
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['BaseScalar']['input']>;
  values?: InputMaybe<Array<Scalars['BaseScalar']['input']>>;
};

export type Random = {
  __typename?: 'Random';
  event?: Maybe<Event>;
  sharry?: Maybe<Sharry>;
  sharrylander?: Maybe<User>;
  wonder?: Maybe<Wonder>;
};

export type Recipe = {
  __typename?: 'Recipe';
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<ItineraryDifficulty>;
  doses?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  ingredients?: Maybe<Scalars['String']['output']>;
  pairing?: Maybe<Scalars['String']['output']>;
  preparation?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RecipeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<ItineraryDifficulty>;
  doses?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  preparation?: InputMaybe<Scalars['String']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<ItineraryDifficulty>;
  doses?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  preparation?: InputMaybe<Scalars['String']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RecommendationCoverPictureInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  original: Scalars['Upload']['input'];
};

export type RecommendationCreateInput = {
  accessibilityCategories?: InputMaybe<Array<ContentCreateAccessibilityInput>>;
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  areYouTheOwner?: InputMaybe<Scalars['Boolean']['input']>;
  attachedDocuments?: InputMaybe<Array<ContentCreateAttachedDocumentInput>>;
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** While i can't really deprecate this, don't use it. Use the nested gallery contents input field */
  coverPicture?: InputMaybe<RecommendationCoverPictureInput>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  /** While i can't really deprecate this, don't use it. Use attached documents */
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  galleryContents?: InputMaybe<Array<ContentCreateGalleryContentInput>>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  hideCreator?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  monthsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  paladinUrls?: InputMaybe<Array<CollaborationUrlUpdate>>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  /** If set to true, the Recommendation starts as published */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  recipe?: InputMaybe<Scalars['JSON']['input']>;
  recommendationKind?: InputMaybe<RecommendationKind>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresBooking?: InputMaybe<Scalars['Boolean']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showMaps?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  suggestedTime?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatItIs?: InputMaybe<Scalars['String']['input']>;
  whatNotToMiss?: InputMaybe<Scalars['String']['input']>;
  whatOther?: InputMaybe<Scalars['String']['input']>;
  whatToRemember?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecial?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecialForYou?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RecommendationKind {
  ItineraryRec = 'itinerary_rec',
  PlaceRec = 'place_rec',
  TraditionRec = 'tradition_rec'
}

export type RecommendationValidateInput = {
  cherries: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export enum ReferenceKind {
  ContentCherry = 'content_cherry',
  ContentOwnerActionLike = 'content_owner_action_like',
  ContentOwnerActionReview = 'content_owner_action_review',
  ContentRanking = 'content_ranking',
  FeaturedContent = 'featured_content',
  FollowerActionLike = 'follower_action_like',
  FollowerActionReview = 'follower_action_review',
  LandCherry = 'land_cherry',
  NewContentGeoloc = 'new_content_geoloc'
}

export type Refund = {
  __typename?: 'Refund';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  adminNote?: Maybe<Scalars['String']['output']>;
  cartItem?: Maybe<CartItem>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  payment?: Maybe<Payment>;
  reason?: Maybe<RefundReason>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
  refundPercentage?: Maybe<Scalars['Float']['output']>;
  refundPictures?: Maybe<Array<RefundPicture>>;
  refusedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  request?: Maybe<RefundRequest>;
  requestFrom?: Maybe<RefundRequestFrom>;
  status?: Maybe<RefundStatus>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type RefundCreateInput = {
  asOwner: Scalars['Boolean']['input'];
  cartItemId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: RefundReason;
  request: RefundRequest;
};

export type RefundPicture = {
  __typename?: 'RefundPicture';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  refund: Refund;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum RefundReason {
  Damaged = 'damaged',
  Family = 'family',
  Health = 'health',
  Other = 'other',
  Unreceived = 'unreceived',
  Work = 'work',
  Wrong = 'wrong'
}

export enum RefundRequest {
  AdminManaged = 'admin_managed',
  Complete = 'complete',
  Partial = 'partial',
  Withdrawal = 'withdrawal'
}

export enum RefundRequestFrom {
  Owner = 'owner',
  User = 'user'
}

export enum RefundStatus {
  Accepted = 'accepted',
  Created = 'created',
  Refused = 'refused'
}

/** Entities that can be reported */
export type ReportableEntity = Event | Place | Post | Sharry | SharryReview | User | Wonder;

export enum ReportableEntityEnum {
  Place = 'place',
  SharryContent = 'sharry_content',
  SharryInstance = 'sharry_instance',
  SharryReview = 'sharry_review',
  User = 'user'
}

export type ReviewClap = {
  __typename?: 'ReviewClap';
  id: Scalars['ID']['output'];
  sharryReview: SharryReview;
  user: User;
};

export type SearchBanner = {
  __typename?: 'SearchBanner';
  aiGenerated: Scalars['Boolean']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use image.url instead. */
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  keyword?: Maybe<Scalars['String']['output']>;
  metaTag?: Maybe<MetaTag>;
  param?: Maybe<Scalars['String']['output']>;
  relatedSearchBanners?: Maybe<Array<SearchBanner>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Array<Scalars['String']['output']>>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchBannerCreateInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  relatedSearchBannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Array<Scalars['String']['input']>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchBannerInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type SearchBannerUpdateInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  relatedSearchBannerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Array<Scalars['String']['input']>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available Comparators */
export enum SearchComparator {
  Cont = 'cont',
  ContArray = 'cont_array',
  ContWord = 'cont_word',
  ContWordStartsWith = 'cont_word_starts_with',
  Dategteq = 'dategteq',
  Datelteq = 'datelteq',
  DoesNotMatch = 'does_not_match',
  Eq = 'eq',
  Gt = 'gt',
  Gteq = 'gteq',
  In = 'in',
  /** value or values are optional and ignored */
  IsBlank = 'is_blank',
  /** value or values are optional and ignored */
  IsFalse = 'is_false',
  /** value or values are optional and ignored */
  IsNotNull = 'is_not_null',
  /** value or values are optional and ignored */
  IsNull = 'is_null',
  /** value or values are optional and ignored */
  IsPresent = 'is_present',
  /** value or values are optional and ignored */
  IsTrue = 'is_true',
  Lt = 'lt',
  Lteq = 'lteq',
  Matches = 'matches',
  MatchesAll = 'matches_all',
  MatchesAny = 'matches_any',
  NotCont = 'not_cont',
  NotEq = 'not_eq',
  NotIn = 'not_in'
}

export type SearchNode = {
  and?: InputMaybe<Array<SearchNode>>;
  or?: InputMaybe<Array<SearchNode>>;
  query?: InputMaybe<QueryNode>;
};

export type SearchableContent = {
  __typename?: 'SearchableContent';
  distance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<SearchableUnion>;
  sharryContent?: Maybe<SharryContent>;
};

/** Types for search results. */
export type SearchableUnion = Event | FeaturedCard | Sharry | User | Wonder;

export enum SeasonEnum {
  Autumn = 'autumn',
  Spring = 'spring',
  Summer = 'summer',
  Winter = 'winter'
}

export type SellingConditionsVersion = {
  __typename?: 'SellingConditionsVersion';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Service = {
  __typename?: 'Service';
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceTypes?: Maybe<Array<ServiceTypeEnum>>;
  sort?: Maybe<Scalars['Int']['output']>;
};

export type ServiceInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceTypes?: InputMaybe<Array<ServiceTypeEnum>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export enum ServiceTypeEnum {
  Accommodation = 'accommodation',
  Experience = 'experience',
  Item = 'item',
  Rental = 'rental',
  SharryMain = 'sharry_main',
  SharryOther = 'sharry_other',
  Tour = 'tour',
  Wonder = 'wonder'
}

export type ServiceUpdateInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<ServiceTypeEnum>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type ServicesSharryContent = {
  __typename?: 'ServicesSharryContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  service: Service;
};

export type ServicesSharryContentsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  serviceId: Scalars['ID']['input'];
};

export type Sharry = SharryContent & {
  __typename?: 'Sharry';
  accessibilityCategories?: Maybe<Array<SharryContentAccessibilityCategory>>;
  address?: Maybe<Scalars['String']['output']>;
  advertisements?: Maybe<Array<Advertisement>>;
  animalsAllowed?: Maybe<Scalars['Boolean']['output']>;
  attachedDocuments?: Maybe<Array<AttachedDocument>>;
  /** Whether the current user previously attended this Sharry */
  attended?: Maybe<Scalars['Boolean']['output']>;
  audio?: Maybe<Scalars['String']['output']>;
  audioDuration?: Maybe<Scalars['Float']['output']>;
  audioSignature?: Maybe<Scalars['String']['output']>;
  audioSignatureDuration?: Maybe<Scalars['Float']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  availableForBusiness?: Maybe<Scalars['Boolean']['output']>;
  availableForBusinessSort?: Maybe<Scalars['Int']['output']>;
  badWeatherInfo?: Maybe<Scalars['String']['output']>;
  bebDescription?: Maybe<Scalars['String']['output']>;
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  cancellationNoticeDays?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<Array<Category>>;
  clappers?: Maybe<Array<User>>;
  clappingReviewCount?: Maybe<Scalars['Int']['output']>;
  collaborations?: Maybe<Array<Collaboration>>;
  contentCarousels?: Maybe<Array<ContentCarousel>>;
  contentFavourites?: Maybe<Array<ContentFavourite>>;
  contentLikes?: Maybe<Array<ContentLike>>;
  contentType?: Maybe<Scalars['String']['output']>;
  coverPicture?: Maybe<GalleryImage>;
  covid19Info?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<ContentOwner>;
  curatedRelatedSharryContents?: Maybe<Array<SharryContent>>;
  customCover?: Maybe<CustomCover>;
  customProvince?: Maybe<Scalars['String']['output']>;
  customRequestsAccepted?: Maybe<Scalars['Boolean']['output']>;
  customRequestsWeekdays?: Maybe<Array<SharryWeekdays>>;
  deliveryTime?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  eventRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  followers?: Maybe<Array<User>>;
  freeSharryKind?: Maybe<FreeSharryKind>;
  galleryContents?: Maybe<Array<GalleryContent>>;
  /** @deprecated Use gallery contents PLS */
  galleryImages?: Maybe<Array<GalleryImage>>;
  genericContact?: Maybe<Scalars['String']['output']>;
  geographicallyRelatedContents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedEvents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharries?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharrylanders?: Maybe<Array<UserSearchResult>>;
  geographicallyRelatedWonders?: Maybe<Array<SharryContent>>;
  hasCustomCover?: Maybe<Scalars['Boolean']['output']>;
  hasMaxParticipants?: Maybe<Scalars['Boolean']['output']>;
  hashtags?: Maybe<Array<Hashtag>>;
  id: Scalars['ID']['output'];
  imTheOwner?: Maybe<Scalars['Boolean']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  invoicesRequestsAccepted?: Maybe<Scalars['Boolean']['output']>;
  involvedEntities?: Maybe<Array<ContentEntity>>;
  involvedSharryContents?: Maybe<Array<SharryContent>>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isOnlineHelper?: Maybe<Scalars['Boolean']['output']>;
  isRecommendation?: Maybe<Scalars['Boolean']['output']>;
  isShadowBanned?: Maybe<Scalars['Boolean']['output']>;
  isVideoEmbedEnabled?: Maybe<Scalars['Boolean']['output']>;
  itinerary?: Maybe<Scalars['JSON']['output']>;
  itineraryNew?: Maybe<Itinerary>;
  keywords?: Maybe<Array<Keyword>>;
  landIds?: Maybe<Array<Scalars['ID']['output']>>;
  languages?: Maybe<Array<Language>>;
  lastCommentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mapPicture?: Maybe<Image>;
  maxAttendants?: Maybe<Scalars['Int']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  meetingLocation?: Maybe<Scalars['String']['output']>;
  meetingLocationLatitude?: Maybe<Scalars['Float']['output']>;
  meetingLocationLongitude?: Maybe<Scalars['Float']['output']>;
  meetingLocationNotes?: Maybe<Scalars['String']['output']>;
  metaTag?: Maybe<MetaTag>;
  minAttendants?: Maybe<Scalars['Int']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  nextUpcomingInstanceDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextUpcomingVariant?: Maybe<SharryVariant>;
  notes?: Maybe<Scalars['String']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<ContentOwner>;
  ownerContentClaps?: Maybe<Array<OwnerContentClap>>;
  ownerContentClapsCount?: Maybe<Scalars['Int']['output']>;
  paladinUrls?: Maybe<Array<CollaborationUrls>>;
  param?: Maybe<Scalars['String']['output']>;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom cover. */
  pictureCollageAsCover?: Maybe<Scalars['Boolean']['output']>;
  pnrr?: Maybe<Scalars['Boolean']['output']>;
  pnrrContent?: Maybe<Pnrr>;
  posterImage?: Maybe<Scalars['JSON']['output']>;
  postsRelated?: Maybe<Array<SharryContent>>;
  postsRelatedCount?: Maybe<Scalars['Int']['output']>;
  practicalInfo?: Maybe<Scalars['String']['output']>;
  pricePerChild?: Maybe<Scalars['Float']['output']>;
  pricePerPerson?: Maybe<Scalars['Float']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publisher?: Maybe<User>;
  recipeNew?: Maybe<Array<Recipe>>;
  reducedMobility?: Maybe<Scalars['Boolean']['output']>;
  reducedMobilityNotes?: Maybe<Scalars['String']['output']>;
  refundable?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rejected?: Maybe<Scalars['Boolean']['output']>;
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rejector?: Maybe<User>;
  requiresBooking?: Maybe<Scalars['Boolean']['output']>;
  requiresPayment?: Maybe<Scalars['Boolean']['output']>;
  responseTime?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<SharryReview>>;
  searchableAddress?: Maybe<Scalars['String']['output']>;
  seasons?: Maybe<Array<SeasonEnum>>;
  services?: Maybe<Array<Service>>;
  servicesSharryContents?: Maybe<Array<ServicesSharryContent>>;
  shadowBanned?: Maybe<Scalars['Boolean']['output']>;
  sharryDiscounts?: Maybe<Array<SharryDiscount>>;
  sharryIndex?: Maybe<Array<SharryContentIndices>>;
  sharryKind?: Maybe<SharryKind>;
  sharryRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  sharrySelection?: Maybe<SharrySelection>;
  sharryVariantDefault?: Maybe<SharryVariant>;
  sharryVariants?: Maybe<Array<SharryVariant>>;
  shipping?: Maybe<Shipping>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCustomCarousels?: Maybe<Scalars['Boolean']['output']>;
  showDirections?: Maybe<Scalars['Boolean']['output']>;
  showMaps?: Maybe<Scalars['Boolean']['output']>;
  showRelatedCarousels?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  soldBySharryland: Scalars['Boolean']['output'];
  splitAgeVariant: Scalars['Boolean']['output'];
  startingPrice?: Maybe<Scalars['Float']['output']>;
  startingPriceKind?: Maybe<StartingPriceKind>;
  startingPriceNotes?: Maybe<Scalars['String']['output']>;
  staticMap?: Maybe<Image>;
  status: SharryContentStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedTime?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  totalReviewCount?: Maybe<Scalars['Int']['output']>;
  unlimitedAttendants?: Maybe<Scalars['Boolean']['output']>;
  unpublishedReviews?: Maybe<Array<SharryReview>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  validatorNotes?: Maybe<Scalars['String']['output']>;
  variantDuration?: Maybe<VariantDuration>;
  /** @deprecated visibility is deprecated. Use suspended/adminHidden status instead. */
  visible?: Maybe<Scalars['Boolean']['output']>;
  visibleAdvertisements?: Maybe<Array<Advertisement>>;
  visitDuration?: Maybe<VisitDuration>;
  website?: Maybe<Scalars['String']['output']>;
  whatToBring?: Maybe<Scalars['String']['output']>;
  whatWeWillDo?: Maybe<Scalars['String']['output']>;
  whatWeWillDoAttachment?: Maybe<AttachedDocument>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  wizardSeenSteps?: Maybe<Array<Scalars['String']['output']>>;
  wonderRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
};


export type SharryLandIdsArgs = {
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharryPostsRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SharrySharryVariantsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharryContent = {
  accessibilityCategories?: Maybe<Array<SharryContentAccessibilityCategory>>;
  address?: Maybe<Scalars['String']['output']>;
  advertisements?: Maybe<Array<Advertisement>>;
  attachedDocuments?: Maybe<Array<AttachedDocument>>;
  audio?: Maybe<Scalars['String']['output']>;
  audioDuration?: Maybe<Scalars['Float']['output']>;
  audioSignature?: Maybe<Scalars['String']['output']>;
  audioSignatureDuration?: Maybe<Scalars['Float']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Category>>;
  clappers?: Maybe<Array<User>>;
  clappingReviewCount?: Maybe<Scalars['Int']['output']>;
  collaborations?: Maybe<Array<Collaboration>>;
  contentCarousels?: Maybe<Array<ContentCarousel>>;
  contentFavourites?: Maybe<Array<ContentFavourite>>;
  contentLikes?: Maybe<Array<ContentLike>>;
  contentType?: Maybe<Scalars['String']['output']>;
  coverPicture?: Maybe<GalleryImage>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<ContentOwner>;
  curatedRelatedSharryContents?: Maybe<Array<SharryContent>>;
  customCover?: Maybe<CustomCover>;
  customProvince?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  eventRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  followers?: Maybe<Array<User>>;
  galleryContents?: Maybe<Array<GalleryContent>>;
  /** @deprecated Use gallery contents PLS */
  galleryImages?: Maybe<Array<GalleryImage>>;
  genericContact?: Maybe<Scalars['String']['output']>;
  geographicallyRelatedContents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedEvents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharries?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharrylanders?: Maybe<Array<UserSearchResult>>;
  geographicallyRelatedWonders?: Maybe<Array<SharryContent>>;
  hasCustomCover?: Maybe<Scalars['Boolean']['output']>;
  hashtags?: Maybe<Array<Hashtag>>;
  id: Scalars['ID']['output'];
  imTheOwner?: Maybe<Scalars['Boolean']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  isRecommendation?: Maybe<Scalars['Boolean']['output']>;
  isShadowBanned?: Maybe<Scalars['Boolean']['output']>;
  itineraryNew?: Maybe<Itinerary>;
  keywords?: Maybe<Array<Keyword>>;
  landIds?: Maybe<Array<Scalars['ID']['output']>>;
  lastCommentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mapPicture?: Maybe<Image>;
  metaTag?: Maybe<MetaTag>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  notes?: Maybe<Scalars['String']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<ContentOwner>;
  ownerContentClaps?: Maybe<Array<OwnerContentClap>>;
  ownerContentClapsCount?: Maybe<Scalars['Int']['output']>;
  paladinUrls?: Maybe<Array<CollaborationUrls>>;
  param?: Maybe<Scalars['String']['output']>;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom cover. */
  pictureCollageAsCover?: Maybe<Scalars['Boolean']['output']>;
  pnrr?: Maybe<Scalars['Boolean']['output']>;
  pnrrContent?: Maybe<Pnrr>;
  posterImage?: Maybe<Scalars['JSON']['output']>;
  postsRelated?: Maybe<Array<SharryContent>>;
  postsRelatedCount?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  recipeNew?: Maybe<Array<Recipe>>;
  region?: Maybe<Scalars['String']['output']>;
  requiresBooking?: Maybe<Scalars['Boolean']['output']>;
  requiresPayment?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<Array<SharryReview>>;
  searchableAddress?: Maybe<Scalars['String']['output']>;
  seasons?: Maybe<Array<SeasonEnum>>;
  sharryDiscounts?: Maybe<Array<SharryDiscount>>;
  sharryIndex?: Maybe<Array<SharryContentIndices>>;
  sharryKind?: Maybe<SharryKind>;
  sharryRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  sharrySelection?: Maybe<SharrySelection>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCustomCarousels?: Maybe<Scalars['Boolean']['output']>;
  showDirections?: Maybe<Scalars['Boolean']['output']>;
  showMaps?: Maybe<Scalars['Boolean']['output']>;
  showRelatedCarousels?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  staticMap?: Maybe<Image>;
  status: SharryContentStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedTime?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  totalReviewCount?: Maybe<Scalars['Int']['output']>;
  unpublishedReviews?: Maybe<Array<SharryReview>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  validatorNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated visibility is deprecated. Use suspended/adminHidden status instead. */
  visible?: Maybe<Scalars['Boolean']['output']>;
  visibleAdvertisements?: Maybe<Array<Advertisement>>;
  visitDuration?: Maybe<VisitDuration>;
  website?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  wizardSeenSteps?: Maybe<Array<Scalars['String']['output']>>;
  wonderRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
};


export type SharryContentLandIdsArgs = {
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharryContentPostsRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SharryContentAccessibilityCategory = {
  __typename?: 'SharryContentAccessibilityCategory';
  accessibilityCategory: AccessibilityCategory;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sharryContent?: Maybe<SharryContent>;
  suitable?: Maybe<Scalars['Boolean']['output']>;
};

export type SharryContentAccessibilityCategoryCreateInput = {
  accessibilityCategoryId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sharryContentId: Scalars['ID']['input'];
};

export type SharryContentAccessibilityCategoryUpdateInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SharryContentAdvertisementCreateInput = {
  advertisementId: Scalars['ID']['input'];
  sharryContentId: Scalars['ID']['input'];
};

export type SharryContentAdvertisementDeleteInput = {
  advertisementId: Scalars['ID']['input'];
  sharryContentId: Scalars['ID']['input'];
};

export type SharryContentAdvertisementUpdateInput = {
  advertisementId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SharryContentIndex = {
  __typename?: 'SharryContentIndex';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  sharryContentId?: Maybe<Scalars['ID']['output']>;
  sharryContentIndexIds?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SharryContentIndices = {
  __typename?: 'SharryContentIndices';
  id?: Maybe<Scalars['ID']['output']>;
  indexType?: Maybe<Scalars['String']['output']>;
  wonders?: Maybe<Array<Wonder>>;
};

export enum SharryContentOwnerType {
  User = 'user'
}

/** Publication status */
export enum SharryContentStatus {
  AdminHidden = 'admin_hidden',
  Banned = 'banned',
  Draft = 'draft',
  Published = 'published',
  Suspended = 'suspended',
  UnderRevision = 'under_revision',
  Validated = 'validated'
}

export enum SharryContentType {
  Event = 'event',
  Post = 'post',
  Sharry = 'sharry',
  Wonder = 'wonder'
}

export type SharryCreateInput = {
  accessibilityCategories?: InputMaybe<Array<ContentCreateAccessibilityInput>>;
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  animalsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  attachedDocuments?: InputMaybe<Array<ContentCreateAttachedDocumentInput>>;
  badWeatherInfo?: InputMaybe<Scalars['String']['input']>;
  bebDescription?: InputMaybe<Scalars['String']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  covid19Info?: InputMaybe<Scalars['String']['input']>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  customRequestsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customRequestsWeekdays?: InputMaybe<Array<SharryWeekdays>>;
  deliveryTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** I can't deprecate this, but use attached documents pls */
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  galleryContents?: InputMaybe<Array<ContentCreateGalleryContentInput>>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  invoicesRequestsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  involvedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineHelper?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoEmbedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  itinerary?: InputMaybe<Scalars['JSON']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  maxAttendants?: InputMaybe<Scalars['Int']['input']>;
  meetingLocation?: InputMaybe<Scalars['String']['input']>;
  meetingLocationLatitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLocationLongitude?: InputMaybe<Scalars['Float']['input']>;
  meetingLocationNotes?: InputMaybe<Scalars['String']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  minAttendants?: InputMaybe<Scalars['Int']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  pictureCollageAsCover?: InputMaybe<Scalars['Boolean']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  practicalInfo?: InputMaybe<Scalars['String']['input']>;
  pricePerChild?: InputMaybe<Scalars['Float']['input']>;
  pricePerPerson?: InputMaybe<Scalars['Float']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  /** If set to true, the Sharry starts as published */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reducedMobility?: InputMaybe<Scalars['Boolean']['input']>;
  reducedMobilityNotes?: InputMaybe<Scalars['String']['input']>;
  refundable?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  responseTime?: InputMaybe<Scalars['Int']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  showDirections?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  soldBySharryland?: InputMaybe<Scalars['Boolean']['input']>;
  startingPrice?: InputMaybe<Scalars['Float']['input']>;
  startingPriceKind?: InputMaybe<StartingPriceKind>;
  startingPriceNotes?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  unlimitedAttendants?: InputMaybe<Scalars['Boolean']['input']>;
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatToBring?: InputMaybe<Scalars['String']['input']>;
  whatWeWillDo?: InputMaybe<Scalars['String']['input']>;
  whatWeWillDoAttachment?: InputMaybe<ContentCreateAttachedDocumentInput>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharryDiscount = {
  __typename?: 'SharryDiscount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kind?: Maybe<SharryDiscountKind>;
  percentage?: Maybe<Scalars['Int']['output']>;
  sharryContent?: Maybe<SharryContent>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type SharryDiscountInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: SharryDiscountKind;
  percentage: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

export enum SharryDiscountKind {
  EarlyBird = 'early_bird',
  LastAvailability = 'last_availability',
  LastMinute = 'last_minute',
  Promo = 'promo'
}

export type SharryKind = {
  __typename?: 'SharryKind';
  contentType?: Maybe<SharryContentType>;
  icon?: Maybe<Image>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nameDe?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameEs?: Maybe<Scalars['String']['output']>;
  nameFr?: Maybe<Scalars['String']['output']>;
  nameIt?: Maybe<Scalars['String']['output']>;
  sharrySelectableKind?: Maybe<SharrySelectableKind>;
};

export type SharryReview = {
  __typename?: 'SharryReview';
  /** @deprecated answer is deprecated. */
  answer?: Maybe<Scalars['String']['output']>;
  /** @deprecated answeredAt is deprecated. */
  answeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SharryReview>>;
  clapping?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  editable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  likeCollection?: Maybe<LikeCollection>;
  modified?: Maybe<Scalars['Boolean']['output']>;
  oldFormat?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<SharryReview>;
  pictures?: Maybe<Array<SharryReviewPicture>>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reviewClaps?: Maybe<Array<ReviewClap>>;
  reviewClapsCount?: Maybe<Scalars['Int']['output']>;
  sharryContent?: Maybe<SharryContent>;
  sharryContentsIds?: Maybe<Array<Scalars['ID']['output']>>;
  taggedUsersIds?: Maybe<Array<Scalars['ID']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  user: User;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type SharryReviewChange = {
  __typename?: 'SharryReviewChange';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  operation?: Maybe<Scalars['String']['output']>;
  sharryReview?: Maybe<SharryReview>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SharryReviewClapCreateInput = {
  sharryReviewId: Scalars['ID']['input'];
};

export type SharryReviewCreateInput = {
  clapping?: InputMaybe<Scalars['Boolean']['input']>;
  likeCollectionId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  sharryContentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taggedUsersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text: Scalars['String']['input'];
};

export type SharryReviewPicture = {
  __typename?: 'SharryReviewPicture';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  sharryReview?: Maybe<SharryReview>;
  shotAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
};

export type SharryReviewPictureCreateInput = {
  image: Scalars['Upload']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  sharryReviewId: Scalars['ID']['input'];
  shotAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type SharryReviewUpdateInput = {
  clapping?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  likeCollectionId?: InputMaybe<Scalars['ID']['input']>;
  modified?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  sharryContentId?: InputMaybe<Scalars['ID']['input']>;
  sharryContentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taggedUsersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharrySelectableKind = {
  __typename?: 'SharrySelectableKind';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  sharryKind: SharryKind;
  sharrySelection?: Maybe<SharrySelection>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum SharrySelection {
  Accommodation = 'accommodation',
  Experience = 'experience',
  Item = 'item',
  MultipleDays = 'multiple_days',
  OfferPost = 'offer_post',
  Rental = 'rental',
  SeekPost = 'seek_post',
  Shop = 'shop',
  SimpleEvent = 'simple_event',
  SimplePost = 'simple_post',
  SingleDay = 'single_day',
  Snapshot = 'snapshot',
  Territory = 'territory',
  Tour = 'tour',
  WithIndex = 'with_index',
  WithItinerary = 'with_itinerary'
}

export type SharryVariant = {
  __typename?: 'SharryVariant';
  availability?: Maybe<Scalars['Int']['output']>;
  available: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  custom?: Maybe<Scalars['Boolean']['output']>;
  default: Scalars['Boolean']['output'];
  definitions: Array<SharryVariantDefinition>;
  discount?: Maybe<SharryDiscount>;
  discountedPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  sharryContent?: Maybe<SharryContent>;
  status: VariantStatusEnum;
  unlimitedAvailability?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type SharryVariantAvailableArgs = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type SharryVariantDefinition = {
  __typename?: 'SharryVariantDefinition';
  beginsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  definitionType?: Maybe<Scalars['String']['output']>;
  definitionValue?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  sharryVariantIds: Array<Scalars['ID']['output']>;
};

export type SharryVariantInput = {
  availability?: InputMaybe<Scalars['Int']['input']>;
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  definitions?: InputMaybe<Array<DefinitionInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<VariantStatusEnum>;
  unlimitedAvailability?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SharryVariantStatus {
  Active = 'active',
  Cancelled = 'cancelled'
}

export enum SharryWeekdays {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export type SharrylandConfig = {
  __typename?: 'SharrylandConfig';
  geographicSearchRange?: Maybe<Scalars['Int']['output']>;
  geographicallyRelatedContentsRange?: Maybe<Scalars['Int']['output']>;
  maximumSharryParticipants?: Maybe<Array<Scalars['Int']['output']>>;
  minimumSharryParticipants?: Maybe<Array<Scalars['Int']['output']>>;
  privacyEmails?: Maybe<Array<Scalars['String']['output']>>;
  recommendationAwardedCherries?: Maybe<Scalars['Int']['output']>;
  sharryAwardedCherries?: Maybe<Scalars['Int']['output']>;
  sharrylanderRelatedCount?: Maybe<Scalars['Int']['output']>;
  sharrylanderSearchCount?: Maybe<Scalars['Int']['output']>;
  staffEmails?: Maybe<Array<Scalars['String']['output']>>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  supportEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type Shipping = {
  __typename?: 'Shipping';
  freeThreshold?: Maybe<Scalars['Boolean']['output']>;
  freeThresholdPrice?: Maybe<Scalars['Float']['output']>;
  homeDelivery?: Maybe<Scalars['Boolean']['output']>;
  homeDeliveryPrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pickupNotesNumber?: Maybe<Scalars['String']['output']>;
  pickupNotesOpenDays?: Maybe<Scalars['String']['output']>;
  pickupPrice?: Maybe<Scalars['Float']['output']>;
  sharryContent?: Maybe<SharryContent>;
  shippingTime?: Maybe<ShippingTime>;
};

export type ShippingCreateInput = {
  freeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  freeThresholdPrice?: InputMaybe<Scalars['Float']['input']>;
  homeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  homeDeliveryPrice?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pickupNotesNumber?: InputMaybe<Scalars['String']['input']>;
  pickupNotesOpenDays?: InputMaybe<Scalars['String']['input']>;
  pickupPrice?: InputMaybe<Scalars['Float']['input']>;
  shippingTime?: InputMaybe<ShippingTime>;
};

export type ShippingInfo = {
  __typename?: 'ShippingInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ShippingInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum ShippingTime {
  FiveDays = 'five_days',
  SevenDays = 'seven_days',
  ThreeDays = 'three_days'
}

export type ShippingUpdateInput = {
  freeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  freeThresholdPrice?: InputMaybe<Scalars['Float']['input']>;
  homeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  homeDeliveryPrice?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pickupNotesNumber?: InputMaybe<Scalars['String']['input']>;
  pickupNotesOpenDays?: InputMaybe<Scalars['String']['input']>;
  pickupPrice?: InputMaybe<Scalars['Float']['input']>;
  shippingTime?: InputMaybe<ShippingTime>;
};

export type ShopOrder = {
  __typename?: 'ShopOrder';
  cartItems?: Maybe<Array<CartItem>>;
  cherryDiscountDeduction?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  giftCardDeduction?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  shippingTotalPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  withShipping: Scalars['Boolean']['output'];
};

export type SignInInput = {
  apple?: InputMaybe<AuthProviderAppleSignInInput>;
  backTo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<AuthProviderEmailSignInInput>;
  facebook?: InputMaybe<AuthProviderFacebookSignInInput>;
  google?: InputMaybe<AuthProviderGoogleSignInInput>;
};

export type SignUpInput = {
  /** Whether the user accepts the current privacy policy or not. */
  acceptsPrivacyPolicy: Scalars['Boolean']['input'];
  /** Whether the user accepts the current terms and conditions or not. */
  acceptsTermsAndConditions: Scalars['Boolean']['input'];
  apple?: InputMaybe<AuthProviderAppleSignUpInput>;
  backTo?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<AuthProviderEmailSignUpInput>;
  facebook?: InputMaybe<AuthProviderFacebookSignUpInput>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  google?: InputMaybe<AuthProviderGoogleSignUpInput>;
  isSmallOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  passwordless?: InputMaybe<Scalars['Boolean']['input']>;
  referralMask?: InputMaybe<Scalars['String']['input']>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortFilter = {
  direction: SortDirection;
  key: Scalars['String']['input'];
  nullsLast?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StartingPriceKind {
  PerGroup = 'per_group',
  PerPerson = 'per_person'
}

export type Subscription = {
  __typename?: 'Subscription';
  cartUpdateSubscription: Cart;
  messageCreated: Message;
  notificationCreated: Notification;
  reviewClapSubscription: SharryReview;
  reviewPictureSubscription: SharryReview;
  reviewSubscription: SharryReviewChange;
};


export type SubscriptionCartUpdateSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionMessageCreatedArgs = {
  recipientId: Scalars['ID']['input'];
};


export type SubscriptionNotificationCreatedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionReviewClapSubscriptionArgs = {
  sharryContentId: Scalars['ID']['input'];
};


export type SubscriptionReviewPictureSubscriptionArgs = {
  sharryContentId: Scalars['ID']['input'];
};


export type SubscriptionReviewSubscriptionArgs = {
  sharryContentId: Scalars['ID']['input'];
};

export type SuggestedSearch = {
  __typename?: 'SuggestedSearch';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  searchString?: Maybe<Scalars['String']['output']>;
  searchUrl?: Maybe<Scalars['String']['output']>;
  searchUrlDe?: Maybe<Scalars['String']['output']>;
  searchUrlEn?: Maybe<Scalars['String']['output']>;
  searchUrlEs?: Maybe<Scalars['String']['output']>;
  searchUrlFr?: Maybe<Scalars['String']['output']>;
  searchUrlIt?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SuggestedSearchInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  searchUrlDe?: InputMaybe<Scalars['String']['input']>;
  searchUrlEn?: InputMaybe<Scalars['String']['input']>;
  searchUrlEs?: InputMaybe<Scalars['String']['input']>;
  searchUrlFr?: InputMaybe<Scalars['String']['input']>;
  searchUrlIt?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamUser = {
  __typename?: 'TeamUser';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<TeamUserKind>;
  user?: Maybe<User>;
};

export enum TeamUserKind {
  Collaborator = 'collaborator',
  Referent = 'referent',
  Team = 'team'
}

export type TermsAndConditionsVersion = {
  __typename?: 'TermsAndConditionsVersion';
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum TransactionType {
  Credit = 'credit',
  Debit = 'debit'
}

export type Transfer = {
  __typename?: 'Transfer';
  amount?: Maybe<Scalars['Int']['output']>;
  cartItem?: Maybe<CartItem>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  formattedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<TransferMetadatum>;
  payment?: Maybe<Payment>;
  sourceTransaction?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransferStatus>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TransferMetadatum = {
  __typename?: 'TransferMetadatum';
  appliedApplicationFee?: Maybe<Scalars['Float']['output']>;
  appliedDiscount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  feeAmount?: Maybe<Scalars['Float']['output']>;
  giftCardAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentAmountNoTaxNoFee?: Maybe<Scalars['Float']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<User>;
  refundDebtCovered?: Maybe<Scalars['Float']['output']>;
  stripeTax?: Maybe<Scalars['Float']['output']>;
  transfer?: Maybe<Transfer>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export enum TransferStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Created = 'created'
}

export type Translation = {
  __typename?: 'Translation';
  en?: Maybe<Scalars['JSON']['output']>;
  it?: Maybe<Scalars['JSON']['output']>;
};

export type TranslationRequestInput = {
  foreignClass: Scalars['String']['input'];
  foreignId: Scalars['ID']['input'];
  locale: Locale;
};

export type UnblockContentInput = {
  contentId: Scalars['ID']['input'];
  contentType: ReportableEntityEnum;
};

export type User = {
  __typename?: 'User';
  accountStripeUid?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use role */
  admin?: Maybe<Scalars['Boolean']['output']>;
  adminLandIds?: Maybe<Array<Scalars['ID']['output']>>;
  adminProfileNotes?: Maybe<Scalars['String']['output']>;
  ambassador?: Maybe<Scalars['Boolean']['output']>;
  anonymised?: Maybe<Scalars['Boolean']['output']>;
  applicationFeePercentage?: Maybe<Scalars['Float']['output']>;
  attachedDocuments?: Maybe<Array<AttachedDocument>>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Not used anymore */
  backTo?: Maybe<Scalars['String']['output']>;
  billingInfo?: Maybe<BillingInfo>;
  billingInfoSet?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Date']['output']>;
  blockedMe: Scalars['Boolean']['output'];
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  canAnonymise: Scalars['Boolean']['output'];
  canBeContacted: Scalars['Boolean']['output'];
  canReportEvents?: Maybe<Scalars['Boolean']['output']>;
  cart?: Maybe<Cart>;
  categories?: Maybe<Array<Category>>;
  cherryTransactions?: Maybe<Array<CherryTransaction>>;
  city?: Maybe<Scalars['String']['output']>;
  clappings?: Maybe<Array<ContentLike>>;
  clappingsCount?: Maybe<Scalars['Int']['output']>;
  completedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  confirmationCode?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactWhatsapp?: Maybe<Scalars['String']['output']>;
  contentLikes?: Maybe<Array<ContentLike>>;
  conversations?: Maybe<Array<Conversation>>;
  coverPicture?: Maybe<UserGalleryImage>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  embed?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  favouriteCategories?: Maybe<Array<Category>>;
  favouriteContents?: Maybe<Array<SharryContent>>;
  favouriteCurrency: CurrencyCode;
  favouriteLanguage: FavouriteLanguage;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fiscalCode?: Maybe<Scalars['String']['output']>;
  followers?: Maybe<Array<User>>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  followings?: Maybe<Array<Follow>>;
  followingsCount?: Maybe<Scalars['Int']['output']>;
  freeProGold?: Maybe<Scalars['Boolean']['output']>;
  friendlyMunicipality?: Maybe<Scalars['Boolean']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  geographicallyRelatedSharryContents?: Maybe<Array<SharryContent>>;
  guest: Scalars['Boolean']['output'];
  hasCreatedWonders?: Maybe<Scalars['Boolean']['output']>;
  hashtags?: Maybe<Array<Hashtag>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isBlockedByMe: Scalars['Boolean']['output'];
  isMe: Scalars['Boolean']['output'];
  isMyContentLike?: Maybe<Scalars['Boolean']['output']>;
  isPaladin?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated pro is deprecated. */
  isPro?: Maybe<Scalars['Boolean']['output']>;
  isProGold?: Maybe<Scalars['Boolean']['output']>;
  isShadowBanned?: Maybe<Scalars['Boolean']['output']>;
  isSmallOrganisation?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated ._. */
  itsaMe: ItsaMe;
  keywords?: Maybe<Array<Keyword>>;
  landIds?: Maybe<Array<Scalars['ID']['output']>>;
  languages?: Maybe<Array<Language>>;
  latitude?: Maybe<Scalars['Float']['output']>;
  likeCollections?: Maybe<Array<LikeCollection>>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxBebs?: Maybe<Scalars['Int']['output']>;
  maxExperiences?: Maybe<Scalars['Int']['output']>;
  maxTours?: Maybe<Scalars['Int']['output']>;
  metaTag?: Maybe<MetaTag>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  /** Sharries owned or created by the user */
  mySharries?: Maybe<Array<SharryContent>>;
  name?: Maybe<Scalars['String']['output']>;
  networkOwnerships?: Maybe<Array<Network>>;
  networkSubscribers?: Maybe<Array<ContentOwner>>;
  networks?: Maybe<Array<Network>>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  originalWhatICanDo?: Maybe<Scalars['String']['output']>;
  originalWhoIAm?: Maybe<Scalars['String']['output']>;
  ownedEventsCount?: Maybe<Scalars['Int']['output']>;
  param?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Payment>>;
  percentageCompletion?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<UserGalleryImage>>;
  plusAttributes?: Maybe<Scalars['JSON']['output']>;
  posterImage?: Maybe<Scalars['JSON']['output']>;
  privacyPolicyAcceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  privacyPolicyVersion?: Maybe<PrivacyPolicyVersion>;
  /** All sharries owned by the user */
  profileAllSharries?: Maybe<Array<SharryContent>>;
  /** Wonders and resources collaborated by the user */
  profileCollaboratedWonders?: Maybe<Array<SharryContent>>;
  /** Visible and not deleted comments (not replies) created by the user */
  profileComments?: Maybe<Array<SharryReview>>;
  profileCommentsCount: Scalars['Int']['output'];
  profileContributesCount: Scalars['Int']['output'];
  /** Recommendations created by the user */
  profileCreatedRecommendations?: Maybe<Array<SharryContent>>;
  profileCreatedSharryContents?: Maybe<Array<SharryContent>>;
  /** Wonders and resources created (but not owned) by the user */
  profileCreatedWonders?: Maybe<Array<SharryContent>>;
  /** Draft events created by the user */
  profileDraftEvents?: Maybe<Array<SharryContent>>;
  /** Draft recommendations created by the user */
  profileDraftRecommendations?: Maybe<Array<SharryContent>>;
  /** Organize events created by the user */
  profileOrganizedEvents?: Maybe<Array<SharryContent>>;
  /** Sharries owned by the user */
  profileOwnedSharries?: Maybe<Array<SharryContent>>;
  profileOwnedSharriesCount: Scalars['Int']['output'];
  /** Experiences owned by the user */
  profileOwnedSharryExperiences?: Maybe<Array<Sharry>>;
  profileOwnedSharryExperiencesCount: Scalars['Int']['output'];
  /** Items owned by the user */
  profileOwnedSharryItems?: Maybe<Array<Sharry>>;
  profileOwnedSharryItemsCount: Scalars['Int']['output'];
  /** Rentals owned by the user */
  profileOwnedSharryRentals?: Maybe<Array<Sharry>>;
  profileOwnedSharryRentalsCount: Scalars['Int']['output'];
  /** Tours owned by the user */
  profileOwnedSharryTours?: Maybe<Array<Sharry>>;
  profileOwnedSharryToursCount: Scalars['Int']['output'];
  /** Wonders and resources owned by the user */
  profileOwnedWonders?: Maybe<Array<SharryContent>>;
  /** Wonders and resources _paladinated_ by the user */
  profilePaladinWonders?: Maybe<Array<SharryContent>>;
  profilePosts?: Maybe<Array<Post>>;
  profilePostsCount?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  publishedContents?: Maybe<Array<SharryContent>>;
  qualification?: Maybe<Qualification>;
  receivedLikes?: Maybe<Array<ContentLike>>;
  referralMask?: Maybe<Scalars['String']['output']>;
  refusedGeolocation?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rejectedRecommendations?: Maybe<Array<SharryContent>>;
  requiresPasswordChange?: Maybe<Scalars['Boolean']['output']>;
  role: UserRole;
  selfSignedQualification?: Maybe<Scalars['Boolean']['output']>;
  sharrylandPartner: Scalars['Boolean']['output'];
  shipping?: Maybe<Shipping>;
  shippingInfo?: Maybe<ShippingInfo>;
  shopInfoConfirmed?: Maybe<Scalars['Boolean']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
  signUpReferral?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripeAccountCompleted?: Maybe<Scalars['Boolean']['output']>;
  stripePayoutsEnabled?: Maybe<Scalars['Boolean']['output']>;
  stripeSubscriptionBeginsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  stripeSubscriptionEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  teamUser?: Maybe<TeamUser>;
  termsAndConditionsAcceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  termsAndConditionsVersion?: Maybe<TermsAndConditionsVersion>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  upgradedToProAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validatedRecommendations?: Maybe<Array<SharryContent>>;
  validationCounter?: Maybe<Scalars['Int']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  whatICanDo?: Maybe<Scalars['String']['output']>;
  whoIAm?: Maybe<Scalars['String']['output']>;
  workAddress?: Maybe<Scalars['String']['output']>;
  workingRange?: Maybe<Scalars['Int']['output']>;
};


export type UserCherryTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type UserClappingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowingsArgs = {
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type UserIsMyContentLikeArgs = {
  id: Scalars['Int']['input'];
  typename: Scalars['String']['input'];
};


export type UserLandIdsArgs = {
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserLikeCollectionsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type UserProfileCollaboratedWondersArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type UserProfileCreatedSharryContentsArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchNode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type UserProfileCreatedWondersArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOrganizedEventsArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOwnedSharriesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOwnedSharryExperiencesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOwnedSharryItemsArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOwnedSharryRentalsArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOwnedSharryToursArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfileOwnedWondersArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfilePaladinWondersArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserProfilePostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UserChangeEmailConfirmInput = {
  confirmationCode: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};

export type UserChangeEmailRequestInput = {
  newEmail: Scalars['String']['input'];
};

export type UserChangeFavouriteCurrencyInput = {
  favouriteCurrency: CurrencyCode;
};

export type UserChangeFavouriteLanguageInput = {
  favouriteLanguage: FavouriteLanguage;
};

export type UserChangePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type UserCherryGoal = {
  __typename?: 'UserCherryGoal';
  cherryGoal: CherryGoal;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  resource?: Maybe<UserCherryGoalResource>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/** Types for user cherry goals. */
export type UserCherryGoalResource = CherryDiscount | GiftCard;

export type UserConfirmEmailInput = {
  userId: Scalars['ID']['input'];
};

export type UserConfirmationCodeInput = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type UserGalleryImage = {
  __typename?: 'UserGalleryImage';
  author?: Maybe<Scalars['String']['output']>;
  copyrightLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isCover?: Maybe<Scalars['Boolean']['output']>;
  licenseType?: Maybe<GalleryContentLicenseEnum>;
  sort?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type UserGalleryImageCreateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserGalleryImageUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  copyrightLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  licenseType?: InputMaybe<GalleryContentLicenseEnum>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type UserReferralMaskInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  referralMask: Scalars['String']['input'];
};

export type UserReport = {
  __typename?: 'UserReport';
  body?: Maybe<Scalars['String']['output']>;
  reportedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type UserReportInput = {
  body: Scalars['String']['input'];
  reportedUserId: Scalars['ID']['input'];
};

export type UserResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

export type UserResetPasswordRequestInput = {
  email: Scalars['String']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRole {
  Admin = 'admin',
  Analyst = 'analyst',
  EventValidator = 'event_validator',
  StandardUser = 'standard_user',
  TrustedUser = 'trusted_user',
  Validator = 'validator'
}

export type UserSearch = {
  __typename?: 'UserSearch';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  searchString?: Maybe<Scalars['String']['output']>;
  searchUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type UserSearchCreateInput = {
  searchString: Scalars['String']['input'];
  searchUrl: Scalars['String']['input'];
};

/** Objects which may be returned from the user search */
export type UserSearchResult = User;

export type UserSignIn = {
  __typename?: 'UserSignIn';
  /** These headers should be attached to every authenticated request. */
  authHeaders: AuthHeaderData;
  user?: Maybe<User>;
};

export type UserUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  adminLandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  backTo?: InputMaybe<Scalars['String']['input']>;
  billingInfoInput?: InputMaybe<BillingInfoInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  canReportEvents?: InputMaybe<Scalars['Boolean']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactWhatsapp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  favouriteCategoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  languagesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  qualificationId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  selfSignedQualification?: InputMaybe<Scalars['Boolean']['input']>;
  shippingInfoInput?: InputMaybe<ShippingInfoInput>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatICanDo?: InputMaybe<Scalars['String']['input']>;
  whoIAm?: InputMaybe<Scalars['String']['input']>;
  workAddress?: InputMaybe<Scalars['String']['input']>;
  workingRange?: InputMaybe<Scalars['Int']['input']>;
};

export type VariantDuration = {
  __typename?: 'VariantDuration';
  createdAt: Scalars['ISO8601DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  durationType?: Maybe<VariantDurationEnum>;
  id: Scalars['ID']['output'];
  sharryContent?: Maybe<Sharry>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum VariantDurationEnum {
  Day = 'day',
  Hour = 'hour'
}

export type VariantDurationInput = {
  duration: Scalars['Float']['input'];
  durationType: VariantDurationEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum VariantStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  Hidden = 'hidden',
  RequestOnly = 'request_only'
}

export type VisitDuration = {
  __typename?: 'VisitDuration';
  id: Scalars['ID']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type VisitDurationInput = {
  sort?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type VisitDurationUpdateInput = {
  id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Visitor = {
  __typename?: 'Visitor';
  newVisitorsCount?: Maybe<Scalars['Int']['output']>;
  oldVisitorsCount?: Maybe<Scalars['Int']['output']>;
};

export type Weather = {
  __typename?: 'Weather';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Wonder = SharryContent & {
  __typename?: 'Wonder';
  accessibilityCategories?: Maybe<Array<SharryContentAccessibilityCategory>>;
  address?: Maybe<Scalars['String']['output']>;
  advertisements?: Maybe<Array<Advertisement>>;
  attachedDocuments?: Maybe<Array<AttachedDocument>>;
  audio?: Maybe<Scalars['String']['output']>;
  audioDuration?: Maybe<Scalars['Float']['output']>;
  audioSignature?: Maybe<Scalars['String']['output']>;
  audioSignatureDuration?: Maybe<Scalars['Float']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  availableCherries?: Maybe<Scalars['Int']['output']>;
  awardedCherries?: Maybe<Scalars['Int']['output']>;
  /** @deprecated not used */
  beginsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Category>>;
  clappers?: Maybe<Array<User>>;
  clappingReviewCount?: Maybe<Scalars['Int']['output']>;
  collaborations?: Maybe<Array<Collaboration>>;
  contentCarousels?: Maybe<Array<ContentCarousel>>;
  contentFavourites?: Maybe<Array<ContentFavourite>>;
  contentLikes?: Maybe<Array<ContentLike>>;
  contentType?: Maybe<Scalars['String']['output']>;
  coverPicture?: Maybe<GalleryImage>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<ContentOwner>;
  curatedRelatedSharryContents?: Maybe<Array<SharryContent>>;
  customCover?: Maybe<CustomCover>;
  customProvince?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated not used */
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  eventRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  followers?: Maybe<Array<User>>;
  galleryContents?: Maybe<Array<GalleryContent>>;
  /** @deprecated Use gallery contents PLS */
  galleryImages?: Maybe<Array<GalleryImage>>;
  genericContact?: Maybe<Scalars['String']['output']>;
  geographicallyExcludedIds?: Maybe<Array<Scalars['ID']['output']>>;
  geographicallyRelatedContents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedEvents?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharries?: Maybe<Array<SharryContent>>;
  geographicallyRelatedSharrylanders?: Maybe<Array<UserSearchResult>>;
  geographicallyRelatedWonders?: Maybe<Array<SharryContent>>;
  /** @deprecated not used */
  hasCalendar?: Maybe<Scalars['Boolean']['output']>;
  hasCustomCover?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not used */
  hasTime?: Maybe<Scalars['Boolean']['output']>;
  hashtags?: Maybe<Array<Hashtag>>;
  /** @deprecated not used */
  hideCreator?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imTheOwner?: Maybe<Scalars['Boolean']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  involvingSharryContents?: Maybe<Array<SharryContent>>;
  isRecommendation?: Maybe<Scalars['Boolean']['output']>;
  isShadowBanned?: Maybe<Scalars['Boolean']['output']>;
  itinerary?: Maybe<Scalars['JSON']['output']>;
  itineraryIndex?: Maybe<Array<Wonder>>;
  itineraryNew?: Maybe<Itinerary>;
  keywords?: Maybe<Array<Keyword>>;
  landIds?: Maybe<Array<Scalars['ID']['output']>>;
  lastCommentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mapPicture?: Maybe<Image>;
  metaTag?: Maybe<MetaTag>;
  months?: Maybe<Array<Month>>;
  municipality?: Maybe<Scalars['String']['output']>;
  myFavourite?: Maybe<ContentLike>;
  myFollow?: Maybe<Follow>;
  notes?: Maybe<Scalars['String']['output']>;
  openingTime?: Maybe<Scalars['String']['output']>;
  originalLanguage?: Maybe<Scalars['String']['output']>;
  originalRecommendation?: Maybe<Wonder>;
  owner?: Maybe<ContentOwner>;
  ownerContentClaps?: Maybe<Array<OwnerContentClap>>;
  ownerContentClapsCount?: Maybe<Scalars['Int']['output']>;
  paladinUrls?: Maybe<Array<CollaborationUrls>>;
  param?: Maybe<Scalars['String']['output']>;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom cover. */
  pictureCollageAsCover?: Maybe<Scalars['Boolean']['output']>;
  pnrr?: Maybe<Scalars['Boolean']['output']>;
  pnrrContent?: Maybe<Pnrr>;
  posterImage?: Maybe<Scalars['JSON']['output']>;
  postsRelated?: Maybe<Array<SharryContent>>;
  postsRelatedCount?: Maybe<Scalars['Int']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publisher?: Maybe<User>;
  recipe?: Maybe<Scalars['JSON']['output']>;
  recipeNew?: Maybe<Array<Recipe>>;
  recommendationKind?: Maybe<RecommendationKind>;
  region?: Maybe<Scalars['String']['output']>;
  rejected?: Maybe<Scalars['Boolean']['output']>;
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rejector?: Maybe<User>;
  requiresBooking?: Maybe<Scalars['Boolean']['output']>;
  requiresPayment?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Resources are deprecated */
  resourceConditions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Resources are deprecated */
  resourceProducts?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Resources are deprecated */
  resourceTextAfter?: Maybe<Scalars['String']['output']>;
  /** @deprecated Resources are deprecated */
  resourceTextBefore?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<SharryReview>>;
  searchableAddress?: Maybe<Scalars['String']['output']>;
  seasons?: Maybe<Array<SeasonEnum>>;
  services?: Maybe<Array<Service>>;
  sharryDiscounts?: Maybe<Array<SharryDiscount>>;
  sharryIndex?: Maybe<Array<SharryContentIndices>>;
  sharryKind?: Maybe<SharryKind>;
  sharryRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  sharrySelection?: Maybe<SharrySelection>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  shortProvince?: Maybe<Scalars['String']['output']>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCustomCarousels?: Maybe<Scalars['Boolean']['output']>;
  showDirections?: Maybe<Scalars['Boolean']['output']>;
  showMaps?: Maybe<Scalars['Boolean']['output']>;
  showRelatedCarousels?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  staticMap?: Maybe<Image>;
  status: SharryContentStatus;
  story?: Maybe<Scalars['String']['output']>;
  /** @deprecated StoryPreview is deprecated. */
  storyPreview?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedTime?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCherries?: Maybe<Scalars['Int']['output']>;
  totalReviewCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated not used */
  travelSuggestions?: Maybe<Scalars['JSON']['output']>;
  unpublishedReviews?: Maybe<Array<SharryReview>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  validatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validatedContent?: Maybe<SharryContent>;
  validator?: Maybe<User>;
  validatorNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated visibility is deprecated. Use suspended/adminHidden status instead. */
  visible?: Maybe<Scalars['Boolean']['output']>;
  visibleAdvertisements?: Maybe<Array<Advertisement>>;
  visitDuration?: Maybe<VisitDuration>;
  website?: Maybe<Scalars['String']['output']>;
  /** @deprecated W questions are deprecated. Use story for all wonders. */
  whatItIs?: Maybe<Scalars['String']['output']>;
  /** @deprecated W questions are deprecated. Use story for all wonders. */
  whatNotToMiss?: Maybe<Scalars['String']['output']>;
  /** @deprecated W questions are deprecated. Use story for all wonders. */
  whatOther?: Maybe<Scalars['String']['output']>;
  /** @deprecated W questions are deprecated. Use story for all wonders. */
  whatToRemember?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  /** @deprecated W questions are deprecated. Use story for all wonders. */
  whyItsSpecial?: Maybe<Scalars['String']['output']>;
  whyItsSpecialForYou?: Maybe<Scalars['String']['output']>;
  wizardSeenSteps?: Maybe<Array<Scalars['String']['output']>>;
  wonderRelatedCarousel?: Maybe<Scalars['Boolean']['output']>;
};


export type WonderLandIdsArgs = {
  deployed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WonderPostsRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type WonderIndex = {
  __typename?: 'WonderIndex';
  id?: Maybe<Scalars['ID']['output']>;
  indexType?: Maybe<Scalars['String']['output']>;
  wonders?: Maybe<Array<Wonder>>;
};

export type WonderUpdateAccessibilityCategoryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  accessibilityCategoryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  suitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WonderUpdateInput = {
  accessibilityCategories?: InputMaybe<Array<WonderUpdateAccessibilityCategoryInput>>;
  address?: InputMaybe<Scalars['String']['input']>;
  advertisementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audio?: InputMaybe<Scalars['Upload']['input']>;
  audioSignature?: InputMaybe<Scalars['Upload']['input']>;
  audioText?: InputMaybe<Scalars['String']['input']>;
  beginsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  curatedRelatedSharryContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customProvince?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  elevation?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  eventRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  featuredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  genericContact?: InputMaybe<Scalars['String']['input']>;
  geographicallyExcludedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomCover?: InputMaybe<Scalars['Boolean']['input']>;
  hasTime?: InputMaybe<Scalars['Boolean']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  hideCreator?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  itinerary?: InputMaybe<Scalars['JSON']['input']>;
  itineraryIndexIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapPicture?: InputMaybe<Scalars['Upload']['input']>;
  metaTag?: InputMaybe<MetaTagInput>;
  monthsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<SharryContentOwnerType>;
  paladinUrls?: InputMaybe<Array<CollaborationUrlUpdate>>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  pictureCollageAsCover?: InputMaybe<Scalars['Boolean']['input']>;
  pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  posterImage?: InputMaybe<Scalars['JSON']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<Scalars['JSON']['input']>;
  recommendationKind?: InputMaybe<RecommendationKind>;
  region?: InputMaybe<Scalars['String']['input']>;
  requiresBooking?: InputMaybe<Scalars['Boolean']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
  resourceConditions?: InputMaybe<Scalars['String']['input']>;
  resourceProducts?: InputMaybe<Scalars['JSON']['input']>;
  resourceTextAfter?: InputMaybe<Scalars['String']['input']>;
  resourceTextBefore?: InputMaybe<Scalars['String']['input']>;
  searchableAddress?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<SeasonEnum>>;
  servicesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharryKindId?: InputMaybe<Scalars['ID']['input']>;
  sharryRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  sharrySelection?: InputMaybe<SharrySelection>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
  shortProvince?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  showDirections?: InputMaybe<Scalars['Boolean']['input']>;
  showMaps?: InputMaybe<Scalars['Boolean']['input']>;
  showRelatedCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  story?: InputMaybe<Scalars['String']['input']>;
  storyPreview?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suggestedTime?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  travelSuggestions?: InputMaybe<Scalars['JSON']['input']>;
  userRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  validatorNotes?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visitDurationId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatItIs?: InputMaybe<Scalars['String']['input']>;
  whatNotToMiss?: InputMaybe<Scalars['String']['input']>;
  whatOther?: InputMaybe<Scalars['String']['input']>;
  whatToRemember?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecial?: InputMaybe<Scalars['String']['input']>;
  whyItsSpecialForYou?: InputMaybe<Scalars['String']['input']>;
  wizardSeenSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  wonderRelatedCarousel?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WrongdoingKind {
  BadBehaviour = 'bad_behaviour',
  ContentChange = 'content_change',
  CopyrightInfringement = 'copyright_infringement',
  IdentityTheft = 'identity_theft',
  InappropriateContent = 'inappropriate_content',
  NeedInformations = 'need_informations',
  NewContent = 'new_content',
  NotCorrect = 'not_correct',
  Other = 'other',
  RequestComplete = 'request_complete'
}

export type WrongdoingReport = {
  __typename?: 'WrongdoingReport';
  admin?: Maybe<User>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<WrongdoingKind>;
  reportedEntity?: Maybe<ReportableEntity>;
  status?: Maybe<WrongdoingStatus>;
};

export type WrongdoingReportCreateInput = {
  body: Scalars['String']['input'];
  kind: WrongdoingKind;
  reportedEntityId: Scalars['ID']['input'];
  reportedEntityType: ReportableEntityEnum;
};

export enum WrongdoingStatus {
  Accepted = 'accepted',
  Closed = 'closed',
  Created = 'created',
  Rejected = 'rejected',
  Reviewed = 'reviewed'
}
